// (function () {
//     function normalizeMoneyText(txt) {
//         const t = (txt || "").trim();
//         if (!t) return "";
//         return t.replace(/\s+/g, " ");
//     }

//     function moneyNumber(txt) {
//         const t = normalizeMoneyText(txt);
//         if (!t) return NaN;
//         const num = t.replace(/[^\d.,]/g, "");
//         if (!num) return NaN;

//         if (num.includes(",") && num.includes(".")) {
//             const lastComma = num.lastIndexOf(",");
//             const lastDot   = num.lastIndexOf(".");

//             if (lastComma > lastDot) {
//                 // European: 1.120,00 → dot = thousands, comma = decimal
//                 return parseFloat(num.replace(/\./g, "").replace(",", "."));
//             }
//             // US / international: 1,120.00 → comma = thousands, dot = decimal
//             return parseFloat(num.replace(/,/g, ""));
//         }

//         if (num.includes(",") && !num.includes(".")) {
//             return parseFloat(num.replace(",", "."));
//         }

//         return parseFloat(num);
//     }

//     function detectFormatSample(txt) {
//         const t = normalizeMoneyText(txt || "");
//         const symbol = (t.match(/[^\d\s.,-]/)?.[0] || "").trim();

//         const hasComma = t.includes(",");
//         const hasDot   = t.includes(".");

//         let usesCommaDecimal = false;
//         if (hasComma && hasDot) {
//             // Both present → last separator is the decimal one
//             usesCommaDecimal = t.lastIndexOf(",") > t.lastIndexOf(".");
//         } else if (hasComma && !hasDot) {
//             usesCommaDecimal = true;
//         }

//         return { symbol: symbol || "£", usesCommaDecimal };
//     }

//     function formatMoney(value, sampleText) {
//         const fmt = detectFormatSample(sampleText);
//         if (!isFinite(value)) return "";

//         const fixed      = value.toFixed(2);
//         const [int, dec] = fixed.split(".");

//         const thousandsSep = fmt.usesCommaDecimal ? "." : ",";
//         const decimalSep   = fmt.usesCommaDecimal ? "," : ".";

//         // Insert thousands separator: 1120 → 1.120
//         const intFormatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);

//         return fmt.symbol + intFormatted + decimalSep + dec;
//     }

//     function getKachingDealBlock(root) {
//         const scope = root || document;
//         const block =
//             scope.querySelector("kaching-bundles-block") ||
//             document.querySelector("kaching-bundles-block");

//         if (!block) return null;

//         const raw = block.getAttribute("deal-block");
//         if (!raw) return null;

//         try {
//             return JSON.parse(raw);
//         } catch (e) {
//             return null;
//         }
//     }

//     function getSelectedDealBarData(selectedBar, root) {
//         if (!selectedBar) return null;

//         const dealId = selectedBar.getAttribute("data-deal-bar-id");
//         if (!dealId) return null;

//         const dealBlock = getKachingDealBlock(root);
//         const bars = dealBlock?.dealBars || [];

//         return bars.find((bar) => bar.id === dealId) || null;
//     }

//     function getDealBarSubtitlePrice(dealBar) {
//         const subtitle = normalizeMoneyText(dealBar?.subtitle || "");
//         return moneyNumber(subtitle);
//     }

//     /*New functions*/
//     function getBarQuantity(bar) {
//         const title = normalizeMoneyText(
//             bar?.querySelector(".kaching-bundles__bar-title")?.textContent || ""
//         );

//         const qty = parseInt(title, 10);
//         return Number.isFinite(qty) && qty > 0 ? qty : 1;
//     }

//     function getBarSubtitleUnitPrice(bar) {
//         const subtitle = normalizeMoneyText(
//             bar?.querySelector(".kaching-bundles__bar-subtitle")?.textContent || ""
//         );

//         return moneyNumber(subtitle);
//     }

//     function nearlyEqual(a, b, epsilon = 0.02) {
//         return isFinite(a) && isFinite(b) && Math.abs(a - b) < epsilon;
//     }

//     function detectBarPriceMode(bar, root) {
//         if (!bar) return "unknown";

//         const dealBlock = getKachingDealBlock(root);

//         if (typeof dealBlock?.showPricesPerItem === "boolean") {
//             return dealBlock.showPricesPerItem ? "unit" : "total";
//         }

//         return "unknown";
//     }

//     function getSelectedKachingPrices(root) {
//         const scope = root || document;
//         const selected =
//             scope.querySelector(".kaching-bundles__bar.kaching-bundles__bar--selected") ||
//             scope.querySelector(".kaching-bundles__bar--selected") ||
//             document.querySelector(".kaching-bundles__bar.kaching-bundles__bar--selected") ||
//             document.querySelector(".kaching-bundles__bar--selected");

//         if (!selected) {
//             return {
//                 priceText: "",
//                 compareText: "",
//                 finalPrice: NaN,
//                 finalCompare: NaN,
//                 mode: "unknown",
//                 quantity: 1
//             };
//         }

//         const rawPriceText = normalizeMoneyText(
//             selected.querySelector(".kaching-bundles__bar-price")?.textContent || ""
//         );
//         const rawCompareText = normalizeMoneyText(
//             selected.querySelector(".kaching-bundles__bar-full-price")?.textContent || ""
//         );

//         const rawPrice = moneyNumber(rawPriceText);
//         const rawCompare = moneyNumber(rawCompareText);

//         const dealBarData = getSelectedDealBarData(selected, root);
//         const mode = detectBarPriceMode(selected, root);

//         let quantity = getBarQuantity(selected);
//         if (typeof dealBarData?.quantity === "number" || typeof dealBarData?.quantity === "string") {
//             const parsedQty = parseInt(dealBarData.quantity, 10);
//             if (Number.isFinite(parsedQty) && parsedQty > 0) {
//                 quantity = parsedQty;
//             }
//         }

//         let finalPrice = rawPrice;
//         let finalCompare = rawCompare;

//         if (mode === "unit") {
//             if (isFinite(rawPrice) && quantity > 0) {
//                 finalPrice = +(rawPrice * quantity).toFixed(2);
//             }

//             if (isFinite(rawCompare) && quantity > 0) {
//                 finalCompare = +(rawCompare * quantity).toFixed(2);
//             }
//         }

//         const priceText = isFinite(finalPrice)
//             ? formatMoney(finalPrice, rawPriceText || rawCompareText)
//             : "";

//         const compareText = isFinite(finalCompare)
//             ? formatMoney(finalCompare, rawCompareText || rawPriceText)
//             : "";

//         return {
//             priceText,
//             compareText,
//             finalPrice,
//             finalCompare,
//             mode,
//             quantity
//         };
//     }

//     /* ─── UNIFIED ATC PRICE WRITER ─── */
//     // Single gate that ALL price-writing paths go through.
//     // Prevents the observer ping-pong between the old three systems.

//     let _atcWriting = false;

//     function writeATCPrices(root) {
//         if (_atcWriting) return;          // ← prevents observer loop
//         _atcWriting = true;

//         try {
//             const scope = root || document;
//             const priceEl   = scope.querySelector("#final-btn") || document.querySelector("#final-btn");
//             const compareEl = scope.querySelector("#compare-btn") || document.querySelector("#compare-btn");
//             const dashEl    = scope.querySelector("#dash") || document.querySelector("#dash");

//             if (!priceEl || !compareEl || !dashEl) return;

//             const { priceText, compareText, finalPrice, finalCompare } = getSelectedKachingPrices(root);

//             const showCompare =
//                 !!compareText &&
//                 isFinite(finalCompare) &&
//                 isFinite(finalPrice) &&
//                 finalCompare > finalPrice;

//             priceEl.textContent   = priceText || "";
//             compareEl.textContent = showCompare ? compareText : "";
//             dashEl.textContent    = showCompare ? " | " : "";
//         } finally {
//             // Release the gate on the NEXT microtask so the MutationObserver
//             // callback that fires synchronously after our writes is still blocked.
//             Promise.resolve().then(() => { _atcWriting = false; });
//         }
//     }

//     // Debounced version for use inside observers / rapid-fire events
//     let _atcRafId = 0;
//     function scheduleWriteATCPrices(root) {
//         cancelAnimationFrame(_atcRafId);
//         _atcRafId = requestAnimationFrame(() => writeATCPrices(root));
//     }

//     /* ─── SINGLE OBSERVER SETUP (replaces lockPricesAgainstKaching + setupPriceSync) ─── */

//     function bindATCPriceObserver(root) {
//         if (window.__atcPriceObsBound) return;
//         window.__atcPriceObsBound = true;

//         const scope = root || document;
//         const priceEl   = scope.querySelector("#final-btn") || document.querySelector("#final-btn");
//         const compareEl = scope.querySelector("#compare-btn") || document.querySelector("#compare-btn");

//         if (!priceEl || !compareEl) return;

//         // Watch the ATC button text – if Kaching or anything else overwrites it,
//         // we re-assert our computed values.
//         const btnObs = new MutationObserver(() => scheduleWriteATCPrices(root));
//         btnObs.observe(priceEl,   { childList: true, subtree: true, characterData: true });
//         btnObs.observe(compareEl, { childList: true, subtree: true, characterData: true });

//         // Watch the Kaching widget for bar-selection class changes
//         const kachingBlock = document.querySelector("kaching-bundles-block");
//         if (kachingBlock) {
//             const kbObs = new MutationObserver(() => scheduleWriteATCPrices(root));
//             kbObs.observe(kachingBlock, { subtree: true, attributes: true, attributeFilter: ["class"] });
//         }
//     }

//     /* ─── KACHING EVENT BINDING (replaces bindKachingPriceSync) ─── */

//     function bindKachingPriceSync(root) {
//         bindATCPriceObserver(root);

//         const block =
//             (root && root.querySelector && root.querySelector("kaching-bundles-block")) ||
//             document.querySelector("kaching-bundles-block");

//         if (block && !block.__priceSyncBound) {
//             block.__priceSyncBound = true;
//             block.addEventListener("deal-bar-selected", () => scheduleWriteATCPrices(root));
//             block.addEventListener("variant-selected",  () => scheduleWriteATCPrices(root));
//         }

//         if (!document.__kachingPriceSyncInit) {
//             document.__kachingPriceSyncInit = true;
//             document.addEventListener("kaching-bundles-initialized", () => scheduleWriteATCPrices(root));
//         }

//         scheduleWriteATCPrices(root);
//     }

//     // Backward-compat aliases used elsewhere in the file
//     function renderATCPricesFromKaching(root) { writeATCPrices(root); }
//     function forceRenderAfterKaching(root)    { scheduleWriteATCPrices(root); }
//     function lockPricesAgainstKaching(root)   { bindATCPriceObserver(root); }

//     function updateButtonPrice(bar) {
//         if (!bar) return;

//         const priceDiscountedChange = bar
//             .querySelector("label .kaching-bundles__bar-main .kaching-bundles__bar-price")
//             ?.textContent?.trim();

//         const priceDiscountChange = bar
//             .querySelector("label .kaching-bundles__bar-main .kaching-bundles__bar-full-price")
//             ?.textContent?.trim();

//         const quantitySelected = bar
//             .querySelector(".kaching-bundles__bar-title")
//             ?.textContent?.trim()
//             .split(" ")[0];

//         const quantityNumber = quantitySelected ? parseInt(quantitySelected) : 1;

//         const dinamicPrice = document.querySelectorAll(".js-dinamic-price");

//         const priceTxt = bar?.querySelector(".kaching-bundles__bar-price")?.textContent?.trim() || "";
//         const total = moneyNumber(priceTxt) || 0;

//         const priceTxtFull = bar?.querySelector(".kaching-bundles__bar-full-price")?.textContent?.trim() || "";
//         const totalFull = moneyNumber(priceTxtFull) || 0;

//         const pricePerUnitDinamic = (moneyNumber(priceDiscountedChange) || 0) / (quantityNumber || 1);

//         dinamicPrice.forEach(function (element) {
//             element.textContent = formatMoney(pricePerUnitDinamic, priceTxt);
//         });

//         const bespaartChange = document.querySelector(".js-bespaart-change");
//         const bundleDesc = document.querySelector(".bundle-description");
//         if (bespaartChange && bundleDesc) {
//             if (totalFull - total > 0) {
//                 const totalSaved = totalFull - total;
//                 bespaartChange.textContent = formatMoney(totalSaved, priceTxt);
//                 bundleDesc.style.display = "flex";
//             } else {
//                 bundleDesc.style.display = "none";
//             }
//         }

//         scheduleWriteATCPrices(document);
//     }

//     function initSectionFunction() {
//         const abRoot = document.querySelector("body.data-selector-ab");
//         if (!abRoot) return;

//         const recEls = abRoot.querySelectorAll(".choice-section .recommendation");
//         let step1Rec, step3Rec;
//         if (recEls.length >= 2) {
//             step1Rec = recEls[0];
//             step3Rec = recEls[1];
//         }

//         let weightGrp = null;
//         let variantGrp = null;
//         const setGroups = () => {
//             weightGrp = abRoot.querySelector('.option-group[data-group="weight"]');
//             variantGrp = abRoot.querySelector('.option-group[data-group="variant"]');
//         };
//         setGroups();

//         function onVariantChangeWeightOnly(e) {
//             const item = e.target.closest(".option-item.js-weight");
//             if (!item) return;

//             const labelEl = item.querySelector(".label");
//             if (!labelEl) return;
//             const variantTitle = labelEl.textContent.trim();

//             item.classList.add("selected");
//             syncBundleVariants(variantTitle);
//         }

//         const learnBtn = abRoot.querySelector(".js-learn-more-btn");
//         const doseModal = abRoot.querySelector(".dose-modal");
//         const doseOverlay = abRoot.querySelector(".dose-modal__overlay");
//         const doseClose = abRoot.querySelector(".dose-modal__close");

//         if (learnBtn && doseModal && doseOverlay) {
//             learnBtn.addEventListener("click", () => {
//                 doseModal.style.display = "grid";
//                 doseOverlay.style.display = "block";
//             });
//         }

//         if (doseOverlay && doseModal) {
//             doseOverlay.addEventListener("click", () => {
//                 doseModal.style.display = "none";
//                 doseOverlay.style.display = "none";
//             });
//         }

//         if (doseClose && doseModal && doseOverlay) {
//             doseClose.addEventListener("click", () => {
//                 doseModal.style.display = "none";
//                 doseOverlay.style.display = "none";
//             });
//         }

//         abRoot.querySelectorAll(".variant-input").forEach((inp) => {
//             inp.addEventListener("change", onVariantChangeWeightOnly);
//         });

//         if (abRoot.querySelector(".t29-b-test-weight")) {
//             abRoot.querySelector(".t29-b-test-weight").style.display = "none";
//             const lastBanner = abRoot.querySelector(".last .info-green-banner");
//             if (lastBanner) lastBanner.style.display = "flex";
//             document.querySelectorAll(".section-number").forEach((el, idx) => {
//                 if (idx == 1) el.textContent = "1";
//                 if (idx == 2) el.textContent = "2";
//             });
//         }

//         const ghTabRegular = abRoot.querySelector(".gh-tab[data-value='regular']");
//         const ghTabGrotehond = abRoot.querySelector(".gh-tab[data-value='grotehond']");
//         const TARGET_SELECTOR = "#MainContent";

//         let IS_NAVIGATING = false;

//         function replaceHeadKachingConfigFromDoc(fetchedDoc) {
//             if (!fetchedDoc) return false;

//             const incoming = fetchedDoc.querySelector('script#kaching-bundles-config[type="application/json"]');
//             if (!incoming) return false;

//             const current = document.querySelector('script#kaching-bundles-config[type="application/json"]');

//             if (!current) {
//                 const clone = incoming.cloneNode(true);
//                 document.head.appendChild(clone);
//                 return true;
//             }

//             current.textContent = incoming.textContent;
//             return true;
//         }

//         function ensureKachingConfigInsideBlockFromHead(blockEl) {
//             if (!blockEl) return false;

//             const inside = blockEl.querySelector('script#kaching-bundles-config[type="application/json"]');
//             if (inside) return true;

//             const headCfg = document.querySelector('script#kaching-bundles-config[type="application/json"]');
//             if (!headCfg) return false;

//             blockEl.querySelectorAll('script[type="application/json"][id*="kaching"]').forEach((n) => n.remove());

//             const clone = headCfg.cloneNode(true);
//             clone.id = "kaching-bundles-config";
//             clone.type = "application/json";
//             blockEl.appendChild(clone);

//             return true;
//         }

//         function updateUrl(url, replace = false) {
//             try {
//                 const u = new URL(url, location.href);
//                 u.hash = "buy-buttons";
//                 const href = u.toString();
//                 const state = { url: href };
//                 if (replace) history.replaceState(state, "", href);
//                 else history.pushState(state, "", href);
//                 return href;
//             } catch (e) { }
//         }

//         function scrollToBuyButtons() {
//             const el = document.getElementById("buy-buttons");
//             if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
//         }

//         window.addEventListener("popstate", (ev) => {
//             const url = ev.state?.url || location.href;
//             if (IS_NAVIGATING) return;
//             IS_NAVIGATING = true;
//             updateFrom(url, { replaceState: true }).finally(() => {
//                 IS_NAVIGATING = false;
//             });
//         });

//         async function reinitKaching(containerId) {
//             const node = document.querySelector(containerId);
//             const target = node ? node.parentNode : null;
//             if (!target) throw new Error(`No ${containerId}`);

//             let host = target.querySelector("kaching-bundles-block");
//             if (!host) {
//                 const external = document.querySelector("kaching-bundles-block");
//                 if (external) {
//                     target.insertBefore(external, target.firstChild || null);
//                     host = external;
//                 }
//             }

//             const cfg = target.querySelector('script#kaching-bundles-config[type="application/json"]');
//             if (!cfg) return;

//             try {
//                 window.kachingBundlesInitialized = false;
//             } catch { }
//             try {
//                 window.kachingBundlesDisableAutoInitialize = false;
//             } catch { }
//             try {
//                 window.kachingBundlesEnabled = true;
//             } catch { }

//             if (typeof window.kachingBundlesInitialize === "function") {
//                 await Promise.resolve();
//                 window.kachingBundlesInitialize();
//             }

//             await new Promise((resolve) => {
//                 const done = () => resolve();
//                 if (window.kachingBundlesInitialized) return resolve();
//                 const onInit = () => {
//                     window.removeEventListener("kaching-bundles-initialized", onInit);
//                     resolve();
//                 };
//                 window.addEventListener("kaching-bundles-initialized", onInit);
//                 setTimeout(done, 6000);
//             });
//         }

//         function showPageLoader(text = "Loading…") {
//             if (document.getElementById("app-loading-overlay")) return;

//             if (!document.getElementById("app-loading-style")) {
//                 const css =
//                     "#app-loading-overlay{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;backdrop-filter:saturate(120%) blur(2px)}" +
//                     "#app-loading-overlay .box{min-width:120px;min-height:120px;border-radius:12px;background:transparent;display:flex;flex-direction:column;gap:10px;align-items:center;justify-content:center;padding:18px;box-shadow:0 8px 30px rgba(0,0,0,.2)}" +
//                     "#app-loading-overlay .spinner{width:36px;height:36px;border-radius:50%;border:4px solid #e5e7eb;border-top-color:#111827;animation:spin 0.8s linear infinite}" +
//                     "#app-loading-overlay .txt{font:500 14px/1.2 system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial; color:#fff}" +
//                     "@keyframes spin{to{transform:rotate(360deg)}}" +
//                     "html.is-loading{cursor:progress}" +
//                     "body.is-loading{pointer-events:none;user-select:none}";
//                 const st = document.createElement("style");
//                 st.id = "app-loading-style";
//                 st.textContent = css;
//                 document.head.appendChild(st);
//             }

//             const overlay = document.createElement("div");
//             overlay.id = "app-loading-overlay";
//             overlay.innerHTML =
//                 '<div class="box"><div class="spinner"></div><div class="txt">' +
//                 text +
//                 "</div></div>";
//             document.body.appendChild(overlay);
//             document.documentElement.classList.add("is-loading");
//             document.body.classList.add("is-loading");
//         }

//         function hidePageLoader() {
//             document.getElementById("app-loading-overlay")?.remove();
//             document.documentElement.classList.remove("is-loading");
//             document.body.classList.remove("is-loading");
//         }

//         async function updateFrom(url, { replaceState = false } = {}) {
//             if (IS_NAVIGATING) return;
//             IS_NAVIGATING = true;
//             showPageLoader();

//             try {
//                 const container = document.querySelector(TARGET_SELECTOR);
//                 if (!container) return;

//                 const sectionEl =
//                     container.closest('[id^="shopify-section-"]') ||
//                     document.querySelector('[id^="shopify-section-"][id$="__main"]');
//                 if (!sectionEl) return;

//                 const sectionId = sectionEl.id.replace(/^shopify-section-/, "");

//                 let sectionJson;
//                 try {
//                     const res = await fetch(`${url}?sections=${encodeURIComponent(sectionId)}`, {
//                         headers: { "X-Requested-With": "XMLHttpRequest" },
//                         credentials: "same-origin"
//                     });
//                     sectionJson = await res.json();
//                 } catch (e) {
//                     return;
//                 }

//                 const sectionHtml = sectionJson?.[sectionId];
//                 if (sectionHtml) {
//                     sectionEl.innerHTML = sectionHtml;
//                     document.dispatchEvent(new CustomEvent("shopify:section:load", { detail: { sectionId } }));
//                     setGroups();
//                 }

//                 let doc = null;
//                 try {
//                     const pageRes = await fetch(url, { credentials: "same-origin" });
//                     const pageHtml = await pageRes.text();
//                     doc = new DOMParser().parseFromString(pageHtml, "text/html");
//                 } catch (e) { }

//                 replaceHeadKachingConfigFromDoc(doc);

//                 const liveKachingBlock =
//                     sectionEl.querySelector(".shopify-app-block kaching-bundle")?.closest(".shopify-app-block") || null;

//                 ensureKachingConfigInsideBlockFromHead(liveKachingBlock);

//                 updateUrl(url, replaceState);

//                 try {
//                     await reinitKaching("kaching-bundle");
//                     // Reset observer flag so it re-binds to new DOM elements
//                     window.__atcPriceObsBound = false;
//                     initSectionFunction();
//                     scrollToBuyButtons();
//                 } catch (e) { }

//                 document.querySelectorAll("kaching-bundle").forEach((kb) => {
//                     kb.style.display = "none";
//                 });

//                 const vp = document.querySelector(".variant-picker__input");
//                 if (vp) vp.style.display = "none";
//             } finally {
//                 hidePageLoader();
//                 IS_NAVIGATING = false;
//             }
//         }

//         ghTabRegular?.addEventListener("click", (e) => {
//             e.preventDefault();
//             updateFrom(ghTabRegular.dataset.url);
//         });

//         ghTabGrotehond?.addEventListener("click", (e) => {
//             e.preventDefault();
//             updateFrom(ghTabGrotehond.dataset.url);
//         });

//         function getBarsFromAnySource(widgetEl) {
//             const attr = widgetEl?.getAttribute("deal-block");
//             if (attr) {
//                 try {
//                     const db = JSON.parse(attr);
//                     if (db?.dealBars?.length) return db.dealBars;
//                 } catch (_) { }
//             }

//             const cfgEl = (widgetEl || document).querySelector('#kaching-bundles-config[type="application/json"]');
//             if (cfgEl) {
//                 try {
//                     const cfg = JSON.parse(cfgEl.textContent || "{}");
//                     if (cfg?.dealBars?.length) return cfg.dealBars;
//                 } catch (_) { }
//             }

//             try {
//                 const maybe = window.kachingBundlesConfig || window.kachingBundlesState || window.kachingBundles;
//                 const bars = maybe?.dealBars || maybe?.state?.dealBars || [];
//                 if (bars.length) return bars;
//             } catch (_) { }

//             return [];
//         }

//         function ensureContainer() {
//             let el = abRoot.querySelector("#container-bundle-selector");
//             if (!el) {
//                 el = document.createElement("div");
//                 el.id = "container-bundle-selector";
//                 const anchor =
//                     abRoot.querySelector("kaching-bundles-block") || abRoot.querySelector("#buy-buttons") || abRoot;
//                 anchor.parentNode.insertBefore(el, anchor);
//             }
//             el.style.display = el.style.display === "none" ? "block" : el.style.display;
//             return el;
//         }

//         function findWidget() {
//             return (
//                 abRoot.querySelector("kaching-bundles-block.kaching-bundles") ||
//                 document.querySelector("kaching-bundles-block.kaching-bundles") ||
//                 abRoot.querySelector("kaching-bundles-block") ||
//                 document.querySelector("kaching-bundles-block")
//             );
//         }

//         function buildCustomSelector(bars, widgetEl, containerEl) {
//             let countDagen = 0;

//             containerEl.innerHTML = bars
//                 .map((bar, idx) => {
//                     const realBar = widgetEl?.querySelector(`.kaching-bundles__bar[data-deal-bar-id="${bar.id}"]`);
//                     const priceTxt = realBar?.querySelector(".kaching-bundles__bar-price")?.textContent?.trim() || "";
//                     const total = moneyNumber(priceTxt) || 0;
//                     if (idx === 0) window.firstPriceSaved = total;

//                     const validation = /\/products\/.*grote-honden/i.test(window.location.pathname);
//                     countDagen = validation ? countDagen + 45 : countDagen + 30;
//                     const countDagenString = String(countDagen);
//                     const displayPrice = total / countDagen;
//                     const priceLimited = displayPrice.toFixed(2);

//                     const priceTxtFull = realBar?.querySelector(".kaching-bundles__bar-full-price")?.textContent?.trim() || "";
//                     const totalFull = moneyNumber(priceTxtFull) || 0;

//                     const priceDiscount = realBar?.querySelector(".kaching-bundles__bar-label")?.textContent?.trim() || "";

//                     let qtyScoops = "";
//                     if (/\/products\/.*dental-powder/i.test(window.location.pathname)) {
//                         qtyScoops = `${/\/products\/.*grote-honden/i.test(window.location.pathname) ? 90 * (idx + 1) + " schepjes" : 60 * (idx + 1) + " schepjes"}`;
//                     } else {
//                         qtyScoops = `${/\/products\/.*grote-honden/i.test(window.location.pathname) ? 90 * (idx + 1) + " chewies" : 60 * (idx + 1) + " chewies"}`;
//                     }

//                     const fmt = detectFormatSample(priceTxt);

//                     if (!abRoot.querySelector(".t29-b-test-weight")) {
//                         return (
//                             `<div class="relative option-item js-selector js-option-item" data-deal-id="${bar.id}" data-price-quantity="${priceTxt}" data-full-price-quantity="${priceTxtFull}" data-bar-id="${idx}">` +
//                             `<div class="option__item_container">` +
//                             (idx === 1 ? `<span class="badge js-badge">Aanbevolen</span>` : "") +
//                             (idx === bars.length - 1 ? `<span class="badge js-badge meeste">MEESTE VOORDEEL</span>` : "") +
//                             `<span class="quantity"><span class="qty-bar">${bar.title}<span class="qty-scoops"> (${qtyScoops})</span></span><span class="js-price">${countDagenString} dagen voorraad</span></span>` +
//                             `<span class="price js-dag" data-price="${total}" data-full-price="${totalFull}" data-count-dag="${countDagen}">${fmt.symbol}${(fmt.usesCommaDecimal ? priceLimited.replace(".", ",") : priceLimited)} per dag (${countDagenString} dagen voorraad)</span>` +
//                             `</div>` +
//                             (priceDiscount.length > 1 ? `<div class="amount_off_tag">${priceDiscount}</div>` : "") +
//                             `</div>`
//                         );
//                     } else {
//                         return (
//                             `<div class="relative option-item js-selector js-option-item" data-deal-id="${bar.id}" data-price-quantity="${priceTxt}" data-full-price-quantity="${priceTxtFull}" data-bar-id="${idx}">` +
//                             `<div class="option__item_container">` +
//                             (idx === 1 ? `<span class="badge js-badge">Aanbevolen</span>` : "") +
//                             (idx === bars.length - 1 ? `<span class="badge js-badge meeste">MEESTE VOORDEEL</span>` : "") +
//                             `<span class="quantity"><span class="qty-bar">${bar.title}</span><span class="js-price">${countDagenString} dagen voorraad</span></span>` +
//                             `<span class="price js-dag" data-price="${total}" data-full-price="${totalFull}" data-count-dag="${countDagen}">${qtyScoops}</span>` +
//                             `</div>` +
//                             (priceDiscount.length > 1 ? `<div class="amount_off_tag">${priceDiscount}</div>` : "") +
//                             `</div>`
//                         );
//                     }
//                 })
//                 .join("");

//             containerEl.querySelectorAll("div.js-option-item").forEach((qtySelector) => {
//                 qtySelector.addEventListener("click", () => {
//                     containerEl.querySelectorAll(".js-option-item.selected").forEach((i) => i.classList.remove("selected"));
//                     qtySelector.classList.add("selected");

//                     const dealId = qtySelector.getAttribute("data-deal-id");
//                     const realRad = abRoot.querySelector(`input[name^="kaching-bundles-deal"][value="${dealId}"]`);
//                     const barEl = realRad ? realRad.closest(".kaching-bundles__bar") : null;

//                     if (realRad) realRad.click();
//                     updateButtonPrice(barEl);

//                     const formEl = document.querySelector("#buy-buttons product-form form");
//                     if (formEl) {
//                         let quantityInput = formEl.querySelector('input[name="quantity"]');
//                         if (!quantityInput) {
//                             quantityInput = document.createElement("input");
//                             quantityInput.type = "hidden";
//                             quantityInput.name = "quantity";
//                             formEl.appendChild(quantityInput);
//                         }

//                         quantityInput.value =
//                             qtySelector.querySelector(".quantity")?.textContent?.trim()?.split(" ")[0] || "1";
//                     }

//                     updateRecs();
//                     scheduleWriteATCPrices(document);
//                 });
//             });
//         }

//         function tryBuildCustomSelector() {
//             const widgetEl = findWidget();
//             const containerEl = ensureContainer();

//             if (!widgetEl) {
//                 document.addEventListener(
//                     "kaching-bundles-initialized",
//                     () => {
//                         const w2 = findWidget();
//                         const bars2 = getBarsFromAnySource(w2);
//                         if (bars2.length) buildCustomSelector(bars2, w2, containerEl);
//                         bindKachingPriceSync(document);
//                     },
//                     { once: true }
//                 );
//                 return;
//             }

//             let bars = getBarsFromAnySource(widgetEl);
//             if (!bars.length) {
//                 const onReady = () => {
//                     const b = getBarsFromAnySource(widgetEl);
//                     if (b.length) {
//                         buildCustomSelector(b, widgetEl, containerEl);
//                         cleanup();
//                         bindKachingPriceSync(document);
//                     }
//                 };
//                 const cleanup = () => {
//                     document.removeEventListener("kaching-bundles-initialized", onReady);
//                     widgetEl.removeEventListener("deal-bar-selected", onReady);
//                     widgetEl.removeEventListener("variant-selected", onReady);
//                 };
//                 document.addEventListener("kaching-bundles-initialized", onReady);
//                 widgetEl.addEventListener("deal-bar-selected", onReady);
//                 widgetEl.addEventListener("variant-selected", onReady);
//                 setTimeout(onReady, 1500);
//                 return;
//             }

//             buildCustomSelector(bars, widgetEl, containerEl);

//             if (bars[1]?.id) {
//                 const toClick = abRoot.querySelector(`[data-deal-id="${bars[1].id}"]`);
//                 if (toClick) toClick.click();
//             }

//             bindKachingPriceSync(document);
//         }

//         tryBuildCustomSelector();

//         const initialInput = abRoot.querySelector(".variant-input:checked");
//         if (initialInput) {
//             const initialItem = initialInput.closest(".option-item");
//             const initialLabelEl = initialItem?.querySelector(".label");
//             if (initialLabelEl) {
//                 syncBundleVariants(initialLabelEl.textContent.trim());
//             }
//         }

//         abRoot.querySelectorAll(".tooltip-wrapper").forEach((tooltip) => {
//             tooltip.addEventListener("mouseover", () => {
//                 tooltip.classList.add("active");
//             });
//             tooltip.addEventListener("mouseout", () => {
//                 tooltip.classList.remove("active");
//             });
//         });

//         abRoot.querySelectorAll(".tooltip-close").forEach((btn) => {
//             btn.addEventListener("click", () => {
//                 const wrapper = btn.closest(".tooltip-wrapper");
//                 if (wrapper) wrapper.classList.remove("active");
//             });
//         });

//         const isLargeDog = /\/products\/.*grote-honden/i.test(window.location.pathname);
//         const LARGE_DOG_WEIGHT_KEY = "gh:lastWeightLargeDog";
//         const LARGE_DOG_ALLOWED = ["20-30", "30-40", "40-50", "above-50"];

//         function saveLargeDogWeight(value) {
//             if (LARGE_DOG_ALLOWED.includes(value)) localStorage.setItem(LARGE_DOG_WEIGHT_KEY, value);
//             else localStorage.removeItem(LARGE_DOG_WEIGHT_KEY);
//         }

//         function getSavedLargeDogWeight() {
//             const v = localStorage.getItem(LARGE_DOG_WEIGHT_KEY);
//             if (LARGE_DOG_ALLOWED.includes(v)) return v;
//         }

//         function applySavedLargeDogWeight() {
//             if (!weightGrp) return;
//             const saved = getSavedLargeDogWeight();
//             if (!saved) return;
//             const savedEl = abRoot.querySelector(`.option-item.js-weight[data-value="${saved}"]`);
//             if (savedEl && abRoot.querySelector(".js-part-grotehond")) {
//                 weightGrp.querySelectorAll(".option-item.selected").forEach((el) => el.classList.remove("selected"));
//                 if (abRoot.querySelector(".js-part-normal")) abRoot.querySelector(".js-part-normal").style.display = "none";
//                 abRoot.querySelector(".js-part-grotehond").style.display = "flex";
//                 abRoot.querySelector(".gh-segment").style.display = "inline-block";
//                 setTimeout(() => {
//                     savedEl.classList.add("selected");
//                     savedEl.click();
//                 }, 500);
//             }
//         }

//         const weightMap = isLargeDog
//             ? { "20-30": 2, "30-40": 3, "40-50": 4, "above-50": 5 }
//             : { "under-10": 1, "10-20": 2, "20-30": 3, "above-30": 4, "30-40": 4, "40-50": 5, "above-50": 6 };

//         const bundleIndexFor = isLargeDog
//             ? { "20-30": 1, "30-40": 1, "40-50": 2, "above-50": 3 }
//             : { "under-10": 1, "10-20": 1, "20-30": 2, "above-30": 3, "30-40": 3, "40-50": 3, "above-50": 3 };

//         function updateRecs() {
//             if (!weightGrp || !step1Rec || !step3Rec) return;
//             const sel1 = weightGrp.querySelector(".option-item.js-weight.selected");
//             const sel2 = abRoot.querySelector(".js-selector.selected.option-item");
//             if (variantGrp) {
//                 const recommendationVariant = abRoot.querySelector(".js-variant-recommendation");
//                 const selVariant = variantGrp.querySelector(".option-item.selected");
//                 if (selVariant && recommendationVariant) {
//                     recommendationVariant.innerHTML = ` ${selVariant.querySelector(".label").textContent}`;
//                 }
//             }
//             if (sel1) {
//                 document.querySelectorAll(".js-hide").forEach((el, index) => {
//                     if (index > sel1.dataset.chews - 1) el.style.display = "none";
//                     else el.style.display = "inline-block";
//                 });

//                 let chewText = "";
//                 if (sel1.dataset.chews == 1) {
//                     chewText = /\/products\/.*dental-powder/i.test(window.location.pathname) ? "schepje" : "snoepje";
//                 } else {
//                     chewText = /\/products\/.*dental-powder/i.test(window.location.pathname) ? "schepjes" : "chewies";
//                 }

//                 step1Rec.innerHTML = `${sel1.querySelector(".label").textContent}`;
//                 const recChews = document.querySelector(".js-recommended-chews");
//                 if (recChews) recChews.innerHTML = `${sel1.dataset.chews} ${chewText} per dag`;
//             }
//             if (sel2) {
//                 step3Rec.innerHTML = sel2.querySelector(".qty-bar").textContent;
//             }
//         }

//         function clickBundle(idx) {
//             const bars = abRoot.querySelectorAll("kaching-bundle .kaching-bundles__bar");
//             if (!bars.length) return;
//             const i = Math.min(Math.max(idx, 0), bars.length - 1);
//             const barClick = bars[i];
//             const label = barClick.querySelector("label");
//             const labelEmulate = abRoot.querySelector('[data-bar-id="' + i + '"]');
//             if (label) label.click();
//             if (labelEmulate) labelEmulate.click();
//             updateButtonPrice(barClick);
//             scheduleWriteATCPrices(document);
//         }

//         function syncBundleVariants(variantTitle) {
//             abRoot
//                 .querySelectorAll("kaching-bundle select.kaching-bundles__bar-variant-select.kaching-bundles-option")
//                 .forEach((selectEl) => {
//                     const option = selectEl.querySelector(
//                         `option.kaching-bundles-option-value[data-value="${variantTitle}"]`
//                     );
//                     if (option) {
//                         selectEl.value = option.value;
//                         selectEl.dispatchEvent(new Event("change", { bubbles: true }));
//                     }
//                 });

//             abRoot.querySelectorAll(".variant-picker__option-values").forEach((selectElOriginal) => {
//                 const optionOriginal = selectElOriginal.querySelector(`label[data-value="${variantTitle}"]`);
//                 if (optionOriginal) optionOriginal.click();
//             });

//             scheduleWriteATCPrices(document);
//         }

//         function updateBundleSubtitles() {
//             if (!weightGrp) return;
//             const sel = weightGrp.querySelector(".option-item.js-weight.selected")?.dataset?.value || "";
//             const d = weightMap[sel] || 2;
//             const daysPerPot = /\/products\/.*grote-honden/i.test(window.location.pathname) ? 90 / d : 60 / d;

//             abRoot.querySelectorAll("#container-bundle-selector .js-selector.js-option-item").forEach((bar) => {
//                 const titleText = bar.querySelector(".quantity")?.textContent?.trim() || "";
//                 const priceDag = bar.querySelector(".js-dag")?.dataset?.price || null;
//                 const qty = parseInt(titleText, 10) || 1;
//                 const days = daysPerPot * qty;

//                 if (priceDag) {
//                     setTimeout(() => {
//                         const voorraadDagen = bar.querySelector(".js-price")?.textContent || "";
//                         const dagChange = (parseFloat(priceDag) / days).toFixed(2);
//                         const sample = bar.getAttribute("data-price-quantity") || "";
//                         const fmt = detectFormatSample(sample);

//                         if (!abRoot.querySelector(".t29-b-test-weight")) {
//                             bar.querySelector(".js-dag").textContent =
//                                 fmt.symbol + (fmt.usesCommaDecimal ? dagChange.replace(".", ",") : dagChange) + ` per dag (${voorraadDagen})`;
//                         } else {
//                             const qs = bar.querySelector(".qty-scoops");
//                             if (qs) qs.style.display = "none";
//                             bar.querySelector(".js-dag").textContent = qs ? qs.textContent : "";
//                         }
//                     }, 5);
//                 }

//                 const subtitleEl = bar.querySelector(".quantity .js-price");
//                 if (subtitleEl) subtitleEl.textContent = `${days.toString().replace(".", ",")} dagen voorraad`;
//             });
//         }

//         const el = document.querySelector("#container-bundle-selector");
//         if (el) {
//             el.style.display = "flex";
//             el.style.visibility = "visible";
//             el.hidden = false;
//             el.style.opacity = 1;
//         }

//         function clickShowGroteHond(item) {
//             if (!item) return;
//             if (item.classList.contains("js-change-grotehond")) {
//                 if (abRoot.querySelector(".js-part-grotehond")) {
//                     abRoot.querySelector(".js-part-normal").style.display = "none";
//                     abRoot.querySelector(".js-part-grotehond").style.display = "flex";
//                 }
//                 abRoot.querySelector(".option-item.js-change-normal")?.nextElementSibling?.click();
//                 abRoot.querySelector(".option-item.js-change-normal")?.nextElementSibling?.classList?.add("selected");
//                 const seg = abRoot.querySelector(".gh-segment");
//                 if (seg) seg.style.display = "inline-block";
//                 setTimeout(() => {
//                     abRoot.querySelector(".gh-tab[data-value='grotehond']")?.click();
//                 }, 600);
//             }
//             if (item.classList.contains("js-change-normal")) {
//                 if (abRoot.querySelector(".option-item.js-change-grotehond")) {
//                     abRoot.querySelector(".option-item.js-change-grotehond")?.previousElementSibling?.click();
//                     abRoot.querySelector(".option-item.js-change-grotehond")?.previousElementSibling?.classList?.add("selected");
//                     if (abRoot.querySelector(".js-part-grotehond")) {
//                         abRoot.querySelector(".js-part-normal").style.display = "flex";
//                         abRoot.querySelector(".js-part-grotehond").style.display = "none";
//                         const seg = abRoot.querySelector(".gh-segment");
//                         if (seg) seg.style.display = "none";
//                     }
//                 }
//                 if (abRoot.querySelector(".gh-tab[data-value='regular']")) {
//                     setTimeout(() => {
//                         abRoot.querySelector(".gh-tab[data-value='regular']")?.click();
//                     }, 600);
//                 }
//             }
//             updateRecs();
//             scheduleWriteATCPrices(document);
//         }

//         function updateBundleBadges() {
//             if (!weightGrp) return;
//             const sel = weightGrp.querySelector(".option-item.js-weight.selected")?.dataset?.value || "";
//             const recIdx = bundleIndexFor[sel] ?? 1;
//             const bars = abRoot.querySelectorAll("#container-bundle-selector .js-selector.js-option-item");
//             if (!bars.length) return;

//             bars.forEach((bar) => {
//                 bar.querySelectorAll(".badge.js-badge, .badge.meeste, .badge").forEach((el) => el.remove());
//             });

//             bars.forEach((bar, idx) => {
//                 const container = bar.querySelector(".option__item_container");
//                 if (!container) return;

//                 if (idx === recIdx && idx < bars.length - 1) {
//                     const badge = document.createElement("span");
//                     badge.className = "badge js-badge";
//                     badge.textContent = "Aanbevolen";
//                     container.appendChild(badge);
//                 } else if (idx === bars.length - 1 && idx != recIdx) {
//                     const badge = document.createElement("span");
//                     badge.className = "badge meeste";
//                     badge.textContent = "MEESTE VOORDEEL";
//                     container.appendChild(badge);
//                 } else if (idx === recIdx && idx === bars.length - 1) {
//                     const badge = document.createElement("span");
//                     badge.className = "badge js-badge";
//                     badge.textContent = "Aanbevolen";
//                     container.appendChild(badge);
//                 }
//             });
//         }

//         function onWeightChange() {
//             updateRecs();
//             const sel = weightGrp.querySelector(".option-item.selected")?.dataset?.value || "";
//             clickBundle(bundleIndexFor[sel] ?? 1);
//             updateBundleSubtitles();
//             updateBundleBadges();
//             const v = weightGrp.querySelector(".option-item.selected")?.getAttribute("data-value");
//             if (v) saveLargeDogWeight(v);
//             scheduleWriteATCPrices(document);
//         }

//         function onVariantChange(e) {
//             const item = e.target.closest(".option-item");
//             if (!item || !variantGrp) return;
//             const variantTitle = item.querySelector(".label")?.textContent?.trim() || "";

//             variantGrp.querySelectorAll(".option-item.selected").forEach((el) => el.classList.remove("selected"));
//             item.classList.add("selected");

//             syncBundleVariants(variantTitle);

//             const activeRad = abRoot.querySelector(`.kaching-bundles__bar.kaching-bundles__bar--selected`);
//             updateButtonPrice(activeRad);
//             updateRecs();
//             scheduleWriteATCPrices(document);
//         }

//         const choiceSection = document.querySelector(".choice-section");
//         if (choiceSection) {
//             choiceSection.addEventListener("click", (e) => {
//                 const itemShow = e.target.closest(".option-item");
//                 clickShowGroteHond(itemShow);
//             });
//         }

//         if (weightGrp) {
//             weightGrp.addEventListener("click", (e) => {
//                 const item = e.target.closest(".option-item");
//                 if (!item) return;
//                 weightGrp.querySelectorAll(".option-item.selected").forEach((el) => el.classList.remove("selected"));
//                 item.classList.add("selected");
//                 onWeightChange();
//             });
//         }

//         abRoot.querySelectorAll(".variant-input").forEach((input) => {
//             input.addEventListener("change", onVariantChange);
//         });

//         applySavedLargeDogWeight();
//         bindKachingPriceSync(document);
//         scheduleWriteATCPrices(document);
//     }

//     document.addEventListener("DOMContentLoaded", function () {
//         const customWidgetContainer = document.querySelectorAll("[option-data-bar-id]");
//         customWidgetContainer.forEach(function (container) {
//             container.addEventListener("click", function () {
//                 const id = container.getAttribute("option-data-bar-id");
//                 const correspondentContainer = document.querySelector(`[data-bar-id="${id}"]`);
//                 if (correspondentContainer) correspondentContainer.click();
//             });
//         });
//     });

//     document.addEventListener("DOMContentLoaded", () => {
//         const MAX_WAIT = 1500;
//         const INTERVAL = 100;
//         let elapsedb = 0;
//         let elapseda = 0;

//         const pollerA = setInterval(() => {
//             if (document.querySelector(".kaching-bundles__bar")) {
//                 clearInterval(pollerA);
//                 document.querySelectorAll(".prod__option-label.prod__option-label__quantity").forEach((el) => {
//                     el.style.display = "none";
//                 });
//                 document
//                     .querySelectorAll(".form__input-wrapper.form__input-wrapper--select.quantity-selector")
//                     .forEach((el) => {
//                         el.style.display = "none";
//                     });
//             } else if ((elapseda += INTERVAL) >= MAX_WAIT) {
//                 clearInterval(pollerA);
//                 document.querySelectorAll("kaching-bundle:not(.custom-bundle)").forEach((el) => {
//                     el.style.display = "block";
//                 });
//             }
//         }, INTERVAL);

//         const pollerb = setInterval(() => {
//             if (document.body.classList.contains("data-selector-ab") && document.querySelector(".kaching-bundles__bar")) {
//                 clearInterval(pollerb);
//                 initSectionFunction();
//                 bindKachingPriceSync(document);
//             } else if ((elapsedb += INTERVAL) >= MAX_WAIT) {
//                 clearInterval(pollerb);
//                 document.querySelectorAll("kaching-bundle").forEach((el) => {
//                     el.style.display = "block";
//                 });

//                 const kachingBundlesBlock = document.querySelector("kaching-bundles-block");
//                 const activeBarKachingInitial = document.querySelector(`.kaching-bundles__bar.kaching-bundles__bar--selected`);
//                 updateButtonPrice(activeBarKachingInitial);
//                 bindKachingPriceSync(document);

//                 if (kachingBundlesBlock && !kachingBundlesBlock.__fallbackPriceBound) {
//                     kachingBundlesBlock.__fallbackPriceBound = true;
//                     kachingBundlesBlock.addEventListener("deal-bar-selected", () => {
//                         const activeBarKaching = document.querySelector(`.kaching-bundles__bar.kaching-bundles__bar--selected`);
//                         updateButtonPrice(activeBarKaching);
//                     });
//                     kachingBundlesBlock.addEventListener("variant-selected", () => {
//                         const activeBarKaching = document.querySelector(`.kaching-bundles__bar.kaching-bundles__bar--selected`);
//                         updateButtonPrice(activeBarKaching);
//                     });
//                 }
//             }
//         }, INTERVAL);
//     });
// })();



// // PRODUCT SELECTOR AJAX NAVIGATION - append to end of section-selector.js

// (function () {

//     if (document.body.classList.contains("data-selector-ab")) return;

//     var IS_NAV = false;

//     function showLoader() {
//         if (document.getElementById("ps-loading-overlay")) return;

//         if (!document.getElementById("ps-loading-style")) {
//             var css =
//                 "#ps-loading-overlay{position:fixed;inset:0;z-index:99999;" +
//                 "background:rgba(0,0,0,.22);display:flex;align-items:center;" +
//                 "justify-content:center;backdrop-filter:saturate(120%) blur(2px)}" +
//                 "#ps-loading-overlay .box{display:flex;flex-direction:column;" +
//                 "gap:10px;align-items:center;justify-content:center;padding:18px}" +
//                 "#ps-loading-overlay .spinner{width:36px;height:36px;" +
//                 "border-radius:50%;border:4px solid rgba(255,255,255,.35);" +
//                 "border-top-color:#fff;animation:ps-spin .8s linear infinite}" +
//                 "@keyframes ps-spin{to{transform:rotate(360deg)}}" +
//                 "body.ps-loading{pointer-events:none;user-select:none}";
//             var st = document.createElement("style");
//             st.id = "ps-loading-style";
//             st.textContent = css;
//             document.head.appendChild(st);
//         }

//         var overlay = document.createElement("div");
//         overlay.id = "ps-loading-overlay";
//         overlay.innerHTML = '<div class="box"><div class="spinner"></div></div>';
//         document.body.appendChild(overlay);
//         document.body.classList.add("ps-loading");
//     }

//     function hideLoader() {
//         var el = document.getElementById("ps-loading-overlay");
//         if (el) el.remove();
//         document.body.classList.remove("ps-loading");
//     }

//     function reExecuteScripts(container) {
//         var _orig = document.addEventListener.bind(document);
//         document.addEventListener = function (type, listener, options) {
//             if (type === "DOMContentLoaded") {
//                 try { listener.call(document, { type: "DOMContentLoaded", target: document }); } catch (e) {}
//                 return;
//             }
//             return _orig(type, listener, options);
//         };
//         try {
//             Array.from(container.querySelectorAll("script")).forEach(function (oldScript) {
//                 var src = oldScript.getAttribute("src") || "";
//                 if (src && document.querySelector('script[src="' + src + '"]')) return;
//                 var type = (oldScript.getAttribute("type") || "").toLowerCase();
//                 if (type === "application/json") return;
//                 var newScript = document.createElement("script");
//                 Array.from(oldScript.attributes).forEach(function (attr) {
//                     newScript.setAttribute(attr.name, attr.value);
//                 });
//                 if (oldScript.textContent) newScript.textContent = oldScript.textContent;
//                 oldScript.parentNode.replaceChild(newScript, oldScript);
//             });
//         } finally {
//             document.addEventListener = _orig;
//         }
//     }

//     function reinitKaching() {
//         return new Promise(function (resolve) {
//             try { window.kachingBundlesInitialized = false; } catch (e) {}
//             try { window.kachingBundlesDisableAutoInitialize = false; } catch (e) {}
//             try { window.kachingBundlesEnabled = true; } catch (e) {}
//             if (typeof window.kachingBundlesInitialize === "function") {
//                 setTimeout(function () { window.kachingBundlesInitialize(); }, 0);
//             }
//             if (window.kachingBundlesInitialized) return resolve();
//             var timer = setTimeout(resolve, 6000);
//             function onDone() {
//                 window.removeEventListener("kaching-bundles-initialized", onDone);
//                 clearTimeout(timer);
//                 resolve();
//             }
//             window.addEventListener("kaching-bundles-initialized", onDone);
//         });
//     }

//     function syncKachingConfig(fetchedDoc) {
//         if (!fetchedDoc) return;
//         var incoming = fetchedDoc.querySelector('script#kaching-bundles-config[type="application/json"]');
//         if (!incoming) return;
//         var current = document.querySelector('script#kaching-bundles-config[type="application/json"]');
//         if (!current) document.head.appendChild(incoming.cloneNode(true));
//         else current.textContent = incoming.textContent;
//     }

//     function updateActiveLink(targetUrl) {
//         document.querySelectorAll(".product-selector-normal, .product-selector-grote").forEach(function (link) {
//             try {
//                 var linkPath = new URL(link.getAttribute("href") || "", location.href).pathname;
//                 var targetPath = new URL(targetUrl, location.href).pathname;
//                 link.classList.toggle("active", linkPath === targetPath);
//             } catch (e) {}
//         });
//     }

//     function pushUrl(url) {
//         try {
//             var u = new URL(url, location.href);
//             history.pushState({ psNav: true, url: u.toString() }, "", u.toString());
//         } catch (e) {}
//     }

//     function navigateTo(url) {
//         if (IS_NAV || !url) return;
//         IS_NAV = true;
//         showLoader();

//         var sectionEl =
//             document.querySelector('[id^="shopify-section-"][id$="__main"]') ||
//             document.querySelector('[id^="shopify-section-"]');

//         if (!sectionEl) {
//             hideLoader();
//             IS_NAV = false;
//             location.href = url;
//             return;
//         }

//         var sectionId = sectionEl.id.replace(/^shopify-section-/, "");

//         fetch(url + "?sections=" + encodeURIComponent(sectionId), {
//             headers: { "X-Requested-With": "XMLHttpRequest" },
//             credentials: "same-origin"
//         })
//         .then(function (res) { return res.json(); })
//         .then(function (json) {
//             var html = json && json[sectionId];
//             if (!html) return;
//             sectionEl.innerHTML = html;
//             document.dispatchEvent(new CustomEvent("shopify:section:load", { bubbles: true, detail: { sectionId: sectionId } }));
//             sectionEl.dispatchEvent(new CustomEvent("shopify:section:load", { bubbles: false, detail: { sectionId: sectionId } }));
//             reExecuteScripts(sectionEl);
//         })
//         .then(function () {
//             return fetch(url, { credentials: "same-origin" })
//                 .then(function (r) { return r.text(); })
//                 .then(function (pageHtml) {
//                     var doc = new DOMParser().parseFromString(pageHtml, "text/html");
//                     syncKachingConfig(doc);
//                     var newTitle = doc.querySelector(".pdp-config-title h1");
//                     var currentTitle = document.querySelector(".pdp-config-title h1");
//                     if (newTitle && currentTitle) currentTitle.textContent = newTitle.textContent;
//                     if (doc.title) document.title = doc.title;
//                 })
//                 .catch(function () {});
//         })
//         .then(function () { return reinitKaching(); })
//         .then(function () {
//             // Reset observer flag so it re-binds after DOM swap
//             window.__atcPriceObsBound = false;

//             pushUrl(url);
//             updateActiveLink(url);
//             bindSelectorLinks();

//             // Re-bind price sync for new DOM
//             var kachingBlock = document.querySelector("kaching-bundles-block");
//             if (kachingBlock) kachingBlock.__psSyncBound = false;
//             if (kachingBlock) kachingBlock.__priceSyncBound = false;

//             // Delay to let Kaching render its bars
//             setTimeout(function () {
//                 var priceEl   = document.getElementById("final-btn");
//                 var compareEl = document.getElementById("compare-btn");
//                 var dashEl    = document.getElementById("dash");

//                 if (priceEl && compareEl && dashEl) {
//                     // Use the shared moneyNumber from the outer IIFE via the
//                     // unified writeATCPrices exposed on the window for this patch
//                     var selectedBar = kachingBlock
//                         ? kachingBlock.querySelector(".kaching-bundles__bar--selected")
//                         : null;

//                     if (selectedBar) {
//                         var barPrice   = selectedBar.querySelector(".kaching-bundles__bar-price");
//                         var barCompare = selectedBar.querySelector(".kaching-bundles__bar-full-price");
//                         var priceTxt   = barPrice   ? barPrice.textContent.trim()   : "";
//                         var compareTxt = barCompare ? barCompare.textContent.trim() : "";

//                         // Use robust parser (same logic as moneyNumber above)
//                         function toNumSafe(txt) {
//                             var s = (txt || "").replace(/[^\d.,]/g, "");
//                             if (!s) return 0;
//                             if (s.indexOf(",") !== -1 && s.indexOf(".") !== -1) {
//                                 if (s.lastIndexOf(",") > s.lastIndexOf(".")) {
//                                     return parseFloat(s.replace(/\./g, "").replace(",", ".")) || 0;
//                                 }
//                                 return parseFloat(s.replace(/,/g, "")) || 0;
//                             }
//                             if (s.indexOf(",") !== -1) return parseFloat(s.replace(",", ".")) || 0;
//                             return parseFloat(s) || 0;
//                         }

//                         var showCompare = !!(compareTxt && toNumSafe(compareTxt) > toNumSafe(priceTxt));

//                         priceEl.textContent   = priceTxt;
//                         compareEl.textContent = showCompare ? compareTxt : "";
//                         dashEl.textContent    = showCompare ? " | " : "";
//                     }
//                 }
//             }, 600);

//             var main = document.getElementById("MainContent");
//             if (main) main.scrollIntoView({ behavior: "smooth", block: "start" });
//             document.dispatchEvent(new CustomEvent("ps:navigation:complete", { bubbles: true, detail: { url: url } }));
//         })
//         .catch(function (err) {
//             console.error("[ProductSelectorNav] Navigation failed:", err);
//             location.href = url;
//         })
//         .finally(function () {
//             hideLoader();
//             IS_NAV = false;
//         });
//     }

//     window.addEventListener("popstate", function (ev) {
//         if (!ev.state || !ev.state.psNav) return;
//         navigateTo(ev.state.url || location.href);
//     });

//     function bindSelectorLinks() {
//         document.querySelectorAll(".product-selector-normal, .product-selector-grote").forEach(function (link) {
//             if (link.__psSelectorBound) return;
//             link.__psSelectorBound = true;
//             link.addEventListener("click", function (e) {
//                 e.preventDefault();
//                 var href = link.getAttribute("href");
//                 if (!href) return;
//                 try {
//                     if (new URL(href, location.href).pathname === location.pathname) return;
//                 } catch (e2) {}
//                 navigateTo(href);
//             });
//         });
//     }

//     if (document.readyState === "loading") {
//         document.addEventListener("DOMContentLoaded", bindSelectorLinks);
//     } else {
//         bindSelectorLinks();
//     }

// })();


// // POST-NAVIGATION PATCH - ingredients popup + ATC price (SIMPLIFIED)

// (function () {

//     if (document.body.classList.contains("data-selector-ab")) return;

//     // Ingredients popup via event delegation
//     if (!document.__ingredientsPopupDelegated) {
//         document.__ingredientsPopupDelegated = true;

//         document.addEventListener("click", function (e) {
//             var btn = e.target.closest("[data-ingredients-popup-open]");
//             if (!btn) return;
//             var popup = document.querySelector('[data-ingredients-popup="' + btn.getAttribute("data-ingredients-popup-open") + '"]');
//             if (popup) popup.removeAttribute("hidden");
//         });

//         document.addEventListener("click", function (e) {
//             var closeBtn = e.target.closest("[data-ingredients-popup-close]");
//             if (!closeBtn) return;
//             var popup = closeBtn.closest("[data-ingredients-popup]");
//             if (popup) popup.setAttribute("hidden", "");
//         });
//     }

//     // ATC price sync after navigation — now delegates to the unified
//     // observer already set up by the main IIFE, so we just re-trigger.
//     document.addEventListener("ps:navigation:complete", function () {
//         var kachingBlock = document.querySelector("kaching-bundles-block");
//         if (kachingBlock) {
//             kachingBlock.__priceSyncBound = false;
//             kachingBlock.__psSyncBound = false;
//         }
//         // The navigateTo handler already does the price injection with
//         // a 600ms delay, so nothing extra needed here.
//     });

// })();

(function () {
    function normalizeMoneyText(txt) {
        const t = (txt || "").trim();
        if (!t) return "";
        return t.replace(/\s+/g, " ");
    }

    function moneyNumber(txt) {
        const t = normalizeMoneyText(txt);
        if (!t) return NaN;
        const num = t.replace(/[^\d.,]/g, "");
        if (!num) return NaN;

        if (num.includes(",") && num.includes(".")) {
            const lastComma = num.lastIndexOf(",");
            const lastDot   = num.lastIndexOf(".");

            if (lastComma > lastDot) {
                // European: 1.120,00 → dot = thousands, comma = decimal
                return parseFloat(num.replace(/\./g, "").replace(",", "."));
            }
            // US / international: 1,120.00 → comma = thousands, dot = decimal
            return parseFloat(num.replace(/,/g, ""));
        }

        if (num.includes(",") && !num.includes(".")) {
            return parseFloat(num.replace(",", "."));
        }

        return parseFloat(num);
    }

    function detectFormatSample(txt) {
        const t = normalizeMoneyText(txt || "");

        // Capture the FULL run of symbol characters (e.g. "zł", not just "z"),
        // and whether it sits before or after the numeric part of the sample
        // (Polish: "327,66 zł" → suffix; e.g. "£327.66" → prefix).
        const match = t.match(/^([^\d]*)([\d\s.,]*\d)([^\d]*)$/);

        let symbol = "£";
        let symbolIsPrefix = true;

        if (match) {
            const [, prefix, , suffix] = match;
            if (suffix.trim()) {
                symbol = suffix.trim();
                symbolIsPrefix = false;
            } else if (prefix.trim()) {
                symbol = prefix.trim();
                symbolIsPrefix = true;
            }
        }

        const hasComma = t.includes(",");
        const hasDot   = t.includes(".");

        let usesCommaDecimal = false;
        if (hasComma && hasDot) {
            // Both present → last separator is the decimal one
            usesCommaDecimal = t.lastIndexOf(",") > t.lastIndexOf(".");
        } else if (hasComma && !hasDot) {
            usesCommaDecimal = true;
        }

        return { symbol, symbolIsPrefix, usesCommaDecimal };
    }

    function formatMoney(value, sampleText) {
        const fmt = detectFormatSample(sampleText);
        if (!isFinite(value)) return "";

        const fixed      = value.toFixed(2);
        const [int, dec] = fixed.split(".");

        const thousandsSep = fmt.usesCommaDecimal ? "." : ",";
        const decimalSep   = fmt.usesCommaDecimal ? "," : ".";

        // Insert thousands separator: 1120 → 1.120
        const intFormatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
        const amount = intFormatted + decimalSep + dec;

        return fmt.symbolIsPrefix ? (fmt.symbol + amount) : (amount + " " + fmt.symbol);
    }

    function getKachingDealBlock(root) {
        const scope = root || document;
        const block =
            scope.querySelector("kaching-bundles-block") ||
            document.querySelector("kaching-bundles-block");

        if (!block) return null;

        const raw = block.getAttribute("deal-block");
        if (!raw) return null;

        try {
            return JSON.parse(raw);
        } catch (e) {
            return null;
        }
    }

    function getSelectedDealBarData(selectedBar, root) {
        if (!selectedBar) return null;

        const dealId = selectedBar.getAttribute("data-deal-bar-id");
        if (!dealId) return null;

        const dealBlock = getKachingDealBlock(root);
        const bars = dealBlock?.dealBars || [];

        return bars.find((bar) => bar.id === dealId) || null;
    }

    function getDealBarSubtitlePrice(dealBar) {
        const subtitle = normalizeMoneyText(dealBar?.subtitle || "");
        return moneyNumber(subtitle);
    }

    /*New functions*/
    function getBarQuantity(bar) {
        const title = normalizeMoneyText(
            bar?.querySelector(".kaching-bundles__bar-title")?.textContent || ""
        );

        const qty = parseInt(title, 10);
        return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }

    function getBarSubtitleUnitPrice(bar) {
        const subtitle = normalizeMoneyText(
            bar?.querySelector(".kaching-bundles__bar-subtitle")?.textContent || ""
        );

        return moneyNumber(subtitle);
    }

    function nearlyEqual(a, b, epsilon = 0.02) {
        return isFinite(a) && isFinite(b) && Math.abs(a - b) < epsilon;
    }

    function detectBarPriceMode(bar, root) {
        if (!bar) return "unknown";

        const dealBlock = getKachingDealBlock(root);

        if (typeof dealBlock?.showPricesPerItem === "boolean") {
            return dealBlock.showPricesPerItem ? "unit" : "total";
        }

        return "unknown";
    }

    function getSelectedKachingPrices(root) {
        const scope = root || document;
        const selected =
            scope.querySelector(".kaching-bundles__bar.kaching-bundles__bar--selected") ||
            scope.querySelector(".kaching-bundles__bar--selected") ||
            document.querySelector(".kaching-bundles__bar.kaching-bundles__bar--selected") ||
            document.querySelector(".kaching-bundles__bar--selected");

        if (!selected) {
            return {
                priceText: "",
                compareText: "",
                finalPrice: NaN,
                finalCompare: NaN,
                mode: "unknown",
                quantity: 1
            };
        }

        const rawPriceText = normalizeMoneyText(
            selected.querySelector(".kaching-bundles__bar-price")?.textContent || ""
        );
        const rawCompareText = normalizeMoneyText(
            selected.querySelector(".kaching-bundles__bar-full-price")?.textContent || ""
        );

        const rawPrice = moneyNumber(rawPriceText);
        const rawCompare = moneyNumber(rawCompareText);

        const dealBarData = getSelectedDealBarData(selected, root);
        const mode = detectBarPriceMode(selected, root);

        let quantity = getBarQuantity(selected);
        if (typeof dealBarData?.quantity === "number" || typeof dealBarData?.quantity === "string") {
            const parsedQty = parseInt(dealBarData.quantity, 10);
            if (Number.isFinite(parsedQty) && parsedQty > 0) {
                quantity = parsedQty;
            }
        }

        let finalPrice = rawPrice;
        let finalCompare = rawCompare;

        if (mode === "unit") {
            if (isFinite(rawPrice) && quantity > 0) {
                finalPrice = +(rawPrice * quantity).toFixed(2);
            }

            if (isFinite(rawCompare) && quantity > 0) {
                finalCompare = +(rawCompare * quantity).toFixed(2);
            }
        }

        const priceText = isFinite(finalPrice)
            ? formatMoney(finalPrice, rawPriceText || rawCompareText)
            : "";

        const compareText = isFinite(finalCompare)
            ? formatMoney(finalCompare, rawCompareText || rawPriceText)
            : "";

        return {
            priceText,
            compareText,
            finalPrice,
            finalCompare,
            mode,
            quantity
        };
    }

    /* ─── UNIFIED ATC PRICE WRITER ─── */
    // Single gate that ALL price-writing paths go through.
    // Prevents the observer ping-pong between the old three systems.

    let _atcWriting = false;

    function writeATCPrices(root) {
        if (_atcWriting) return;          // ← prevents observer loop
        _atcWriting = true;

        try {
            const scope = root || document;
            const priceEl   = scope.querySelector("#final-btn") || document.querySelector("#final-btn");
            const compareEl = scope.querySelector("#compare-btn") || document.querySelector("#compare-btn");
            const dashEl    = scope.querySelector("#dash") || document.querySelector("#dash");

            if (!priceEl || !compareEl || !dashEl) return;

            const { priceText, compareText, finalPrice, finalCompare } = getSelectedKachingPrices(root);

            const showCompare =
                !!compareText &&
                isFinite(finalCompare) &&
                isFinite(finalPrice) &&
                finalCompare > finalPrice;

            priceEl.textContent   = priceText || "";
            compareEl.textContent = showCompare ? compareText : "";
            dashEl.textContent    = showCompare ? " | " : "";
        } finally {
            // Release the gate on the NEXT microtask so the MutationObserver
            // callback that fires synchronously after our writes is still blocked.
            Promise.resolve().then(() => { _atcWriting = false; });
        }
    }

    // Debounced version for use inside observers / rapid-fire events
    let _atcRafId = 0;
    function scheduleWriteATCPrices(root) {
        cancelAnimationFrame(_atcRafId);
        _atcRafId = requestAnimationFrame(() => writeATCPrices(root));
    }

    /* ─── SINGLE OBSERVER SETUP (replaces lockPricesAgainstKaching + setupPriceSync) ─── */

    function bindATCPriceObserver(root) {
        if (window.__atcPriceObsBound) return;
        window.__atcPriceObsBound = true;

        const scope = root || document;
        const priceEl   = scope.querySelector("#final-btn") || document.querySelector("#final-btn");
        const compareEl = scope.querySelector("#compare-btn") || document.querySelector("#compare-btn");

        if (!priceEl || !compareEl) return;

        // Watch the ATC button text – if Kaching or anything else overwrites it,
        // we re-assert our computed values.
        const btnObs = new MutationObserver(() => scheduleWriteATCPrices(root));
        btnObs.observe(priceEl,   { childList: true, subtree: true, characterData: true });
        btnObs.observe(compareEl, { childList: true, subtree: true, characterData: true });

        // Watch the Kaching widget for bar-selection class changes
        const kachingBlock = document.querySelector("kaching-bundles-block");
        if (kachingBlock) {
            const kbObs = new MutationObserver(() => scheduleWriteATCPrices(root));
            kbObs.observe(kachingBlock, { subtree: true, attributes: true, attributeFilter: ["class"] });
        }
    }

    /* ─── KACHING EVENT BINDING (replaces bindKachingPriceSync) ─── */

    function bindKachingPriceSync(root) {
        bindATCPriceObserver(root);

        const block =
            (root && root.querySelector && root.querySelector("kaching-bundles-block")) ||
            document.querySelector("kaching-bundles-block");

        if (block && !block.__priceSyncBound) {
            block.__priceSyncBound = true;
            block.addEventListener("deal-bar-selected", () => scheduleWriteATCPrices(root));
            block.addEventListener("variant-selected",  () => scheduleWriteATCPrices(root));
        }

        if (!document.__kachingPriceSyncInit) {
            document.__kachingPriceSyncInit = true;
            document.addEventListener("kaching-bundles-initialized", () => scheduleWriteATCPrices(root));
        }

        scheduleWriteATCPrices(root);
    }

    // Backward-compat aliases used elsewhere in the file
    function renderATCPricesFromKaching(root) { writeATCPrices(root); }
    function forceRenderAfterKaching(root)    { scheduleWriteATCPrices(root); }
    function lockPricesAgainstKaching(root)   { bindATCPriceObserver(root); }

    function updateButtonPrice(bar) {
        if (!bar) return;

        const priceDiscountedChange = bar
            .querySelector("label .kaching-bundles__bar-main .kaching-bundles__bar-price")
            ?.textContent?.trim();

        const priceDiscountChange = bar
            .querySelector("label .kaching-bundles__bar-main .kaching-bundles__bar-full-price")
            ?.textContent?.trim();

        const quantitySelected = bar
            .querySelector(".kaching-bundles__bar-title")
            ?.textContent?.trim()
            .split(" ")[0];

        const quantityNumber = quantitySelected ? parseInt(quantitySelected) : 1;

        const dinamicPrice = document.querySelectorAll(".js-dinamic-price");

        const priceTxt = bar?.querySelector(".kaching-bundles__bar-price")?.textContent?.trim() || "";
        const total = moneyNumber(priceTxt) || 0;

        const priceTxtFull = bar?.querySelector(".kaching-bundles__bar-full-price")?.textContent?.trim() || "";
        const totalFull = moneyNumber(priceTxtFull) || 0;

        const pricePerUnitDinamic = (moneyNumber(priceDiscountedChange) || 0) / (quantityNumber || 1);

        dinamicPrice.forEach(function (element) {
            element.textContent = formatMoney(pricePerUnitDinamic, priceTxt);
        });

        const bespaartChange = document.querySelector(".js-bespaart-change");
        const bundleDesc = document.querySelector(".bundle-description");
        if (bespaartChange && bundleDesc) {
            if (totalFull - total > 0) {
                const totalSaved = totalFull - total;
                bespaartChange.textContent = formatMoney(totalSaved, priceTxt);
                bundleDesc.style.display = "flex";
            } else {
                bundleDesc.style.display = "none";
            }
        }

        scheduleWriteATCPrices(document);
    }

    function initSectionFunction() {
        const abRoot = document.querySelector("body.data-selector-ab");
        if (!abRoot) return;

        const recEls = abRoot.querySelectorAll(".choice-section .recommendation");
        let step1Rec, step3Rec;
        if (recEls.length >= 2) {
            step1Rec = recEls[0];
            step3Rec = recEls[1];
        }

        let weightGrp = null;
        let variantGrp = null;
        const setGroups = () => {
            weightGrp = abRoot.querySelector('.option-group[data-group="weight"]');
            variantGrp = abRoot.querySelector('.option-group[data-group="variant"]');
        };
        setGroups();

        function onVariantChangeWeightOnly(e) {
            const item = e.target.closest(".option-item.js-weight");
            if (!item) return;

            const labelEl = item.querySelector(".label");
            if (!labelEl) return;
            const variantTitle = labelEl.textContent.trim();

            item.classList.add("selected");
            syncBundleVariants(variantTitle);
        }

        const learnBtn = abRoot.querySelector(".js-learn-more-btn");
        const doseModal = abRoot.querySelector(".dose-modal");
        const doseOverlay = abRoot.querySelector(".dose-modal__overlay");
        const doseClose = abRoot.querySelector(".dose-modal__close");

        if (learnBtn && doseModal && doseOverlay) {
            learnBtn.addEventListener("click", () => {
                doseModal.style.display = "grid";
                doseOverlay.style.display = "block";
            });
        }

        if (doseOverlay && doseModal) {
            doseOverlay.addEventListener("click", () => {
                doseModal.style.display = "none";
                doseOverlay.style.display = "none";
            });
        }

        if (doseClose && doseModal && doseOverlay) {
            doseClose.addEventListener("click", () => {
                doseModal.style.display = "none";
                doseOverlay.style.display = "none";
            });
        }

        abRoot.querySelectorAll(".variant-input").forEach((inp) => {
            inp.addEventListener("change", onVariantChangeWeightOnly);
        });

        if (abRoot.querySelector(".t29-b-test-weight")) {
            abRoot.querySelector(".t29-b-test-weight").style.display = "none";
            const lastBanner = abRoot.querySelector(".last .info-green-banner");
            if (lastBanner) lastBanner.style.display = "flex";
            document.querySelectorAll(".section-number").forEach((el, idx) => {
                if (idx == 1) el.textContent = "1";
                if (idx == 2) el.textContent = "2";
            });
        }

        const ghTabRegular = abRoot.querySelector(".gh-tab[data-value='regular']");
        const ghTabGrotehond = abRoot.querySelector(".gh-tab[data-value='grotehond']");
        const TARGET_SELECTOR = "#MainContent";

        let IS_NAVIGATING = false;

        function replaceHeadKachingConfigFromDoc(fetchedDoc) {
            if (!fetchedDoc) return false;

            const incoming = fetchedDoc.querySelector('script#kaching-bundles-config[type="application/json"]');
            if (!incoming) return false;

            const current = document.querySelector('script#kaching-bundles-config[type="application/json"]');

            if (!current) {
                const clone = incoming.cloneNode(true);
                document.head.appendChild(clone);
                return true;
            }

            current.textContent = incoming.textContent;
            return true;
        }

        function ensureKachingConfigInsideBlockFromHead(blockEl) {
            if (!blockEl) return false;

            const inside = blockEl.querySelector('script#kaching-bundles-config[type="application/json"]');
            if (inside) return true;

            const headCfg = document.querySelector('script#kaching-bundles-config[type="application/json"]');
            if (!headCfg) return false;

            blockEl.querySelectorAll('script[type="application/json"][id*="kaching"]').forEach((n) => n.remove());

            const clone = headCfg.cloneNode(true);
            clone.id = "kaching-bundles-config";
            clone.type = "application/json";
            blockEl.appendChild(clone);

            return true;
        }

        function updateUrl(url, replace = false) {
            try {
                const u = new URL(url, location.href);
                u.hash = "buy-buttons";
                const href = u.toString();
                const state = { url: href };
                if (replace) history.replaceState(state, "", href);
                else history.pushState(state, "", href);
                return href;
            } catch (e) { }
        }

        function scrollToBuyButtons() {
            const el = document.getElementById("buy-buttons");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }

        window.addEventListener("popstate", (ev) => {
            const url = ev.state?.url || location.href;
            if (IS_NAVIGATING) return;
            IS_NAVIGATING = true;
            updateFrom(url, { replaceState: true }).finally(() => {
                IS_NAVIGATING = false;
            });
        });

        async function reinitKaching(containerId) {
            const node = document.querySelector(containerId);
            const target = node ? node.parentNode : null;
            if (!target) throw new Error(`No ${containerId}`);

            let host = target.querySelector("kaching-bundles-block");
            if (!host) {
                const external = document.querySelector("kaching-bundles-block");
                if (external) {
                    target.insertBefore(external, target.firstChild || null);
                    host = external;
                }
            }

            const cfg = target.querySelector('script#kaching-bundles-config[type="application/json"]');
            if (!cfg) return;

            try {
                window.kachingBundlesInitialized = false;
            } catch { }
            try {
                window.kachingBundlesDisableAutoInitialize = false;
            } catch { }
            try {
                window.kachingBundlesEnabled = true;
            } catch { }

            if (typeof window.kachingBundlesInitialize === "function") {
                await Promise.resolve();
                window.kachingBundlesInitialize();
            }

            await new Promise((resolve) => {
                const done = () => resolve();
                if (window.kachingBundlesInitialized) return resolve();
                const onInit = () => {
                    window.removeEventListener("kaching-bundles-initialized", onInit);
                    resolve();
                };
                window.addEventListener("kaching-bundles-initialized", onInit);
                setTimeout(done, 6000);
            });
        }

        function showPageLoader(text = "Loading…") {
            if (document.getElementById("app-loading-overlay")) return;

            if (!document.getElementById("app-loading-style")) {
                const css =
                    "#app-loading-overlay{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;backdrop-filter:saturate(120%) blur(2px)}" +
                    "#app-loading-overlay .box{min-width:120px;min-height:120px;border-radius:12px;background:transparent;display:flex;flex-direction:column;gap:10px;align-items:center;justify-content:center;padding:18px;box-shadow:0 8px 30px rgba(0,0,0,.2)}" +
                    "#app-loading-overlay .spinner{width:36px;height:36px;border-radius:50%;border:4px solid #e5e7eb;border-top-color:#111827;animation:spin 0.8s linear infinite}" +
                    "#app-loading-overlay .txt{font:500 14px/1.2 system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial; color:#fff}" +
                    "@keyframes spin{to{transform:rotate(360deg)}}" +
                    "html.is-loading{cursor:progress}" +
                    "body.is-loading{pointer-events:none;user-select:none}";
                const st = document.createElement("style");
                st.id = "app-loading-style";
                st.textContent = css;
                document.head.appendChild(st);
            }

            const overlay = document.createElement("div");
            overlay.id = "app-loading-overlay";
            overlay.innerHTML =
                '<div class="box"><div class="spinner"></div><div class="txt">' +
                text +
                "</div></div>";
            document.body.appendChild(overlay);
            document.documentElement.classList.add("is-loading");
            document.body.classList.add("is-loading");
        }

        function hidePageLoader() {
            document.getElementById("app-loading-overlay")?.remove();
            document.documentElement.classList.remove("is-loading");
            document.body.classList.remove("is-loading");
        }

        async function updateFrom(url, { replaceState = false } = {}) {
            if (IS_NAVIGATING) return;
            IS_NAVIGATING = true;
            showPageLoader();

            try {
                const container = document.querySelector(TARGET_SELECTOR);
                if (!container) return;

                const sectionEl =
                    container.closest('[id^="shopify-section-"]') ||
                    document.querySelector('[id^="shopify-section-"][id$="__main"]');
                if (!sectionEl) return;

                const sectionId = sectionEl.id.replace(/^shopify-section-/, "");

                let sectionJson;
                try {
                    const res = await fetch(`${url}?sections=${encodeURIComponent(sectionId)}`, {
                        headers: { "X-Requested-With": "XMLHttpRequest" },
                        credentials: "same-origin"
                    });
                    sectionJson = await res.json();
                } catch (e) {
                    return;
                }

                const sectionHtml = sectionJson?.[sectionId];
                if (sectionHtml) {
                    sectionEl.innerHTML = sectionHtml;
                    document.dispatchEvent(new CustomEvent("shopify:section:load", { detail: { sectionId } }));
                    setGroups();
                }

                let doc = null;
                try {
                    const pageRes = await fetch(url, { credentials: "same-origin" });
                    const pageHtml = await pageRes.text();
                    doc = new DOMParser().parseFromString(pageHtml, "text/html");
                } catch (e) { }

                replaceHeadKachingConfigFromDoc(doc);

                const liveKachingBlock =
                    sectionEl.querySelector(".shopify-app-block kaching-bundle")?.closest(".shopify-app-block") || null;

                ensureKachingConfigInsideBlockFromHead(liveKachingBlock);

                updateUrl(url, replaceState);

                try {
                    await reinitKaching("kaching-bundle");
                    // Reset observer flag so it re-binds to new DOM elements
                    window.__atcPriceObsBound = false;
                    initSectionFunction();
                    scrollToBuyButtons();
                } catch (e) { }

                document.querySelectorAll("kaching-bundle").forEach((kb) => {
                    kb.style.display = "none";
                });

                const vp = document.querySelector(".variant-picker__input");
                if (vp) vp.style.display = "none";
            } finally {
                hidePageLoader();
                IS_NAVIGATING = false;
            }
        }

        ghTabRegular?.addEventListener("click", (e) => {
            e.preventDefault();
            updateFrom(ghTabRegular.dataset.url);
        });

        ghTabGrotehond?.addEventListener("click", (e) => {
            e.preventDefault();
            updateFrom(ghTabGrotehond.dataset.url);
        });

        function getBarsFromAnySource(widgetEl) {
            const attr = widgetEl?.getAttribute("deal-block");
            if (attr) {
                try {
                    const db = JSON.parse(attr);
                    if (db?.dealBars?.length) return db.dealBars;
                } catch (_) { }
            }

            const cfgEl = (widgetEl || document).querySelector('#kaching-bundles-config[type="application/json"]');
            if (cfgEl) {
                try {
                    const cfg = JSON.parse(cfgEl.textContent || "{}");
                    if (cfg?.dealBars?.length) return cfg.dealBars;
                } catch (_) { }
            }

            try {
                const maybe = window.kachingBundlesConfig || window.kachingBundlesState || window.kachingBundles;
                const bars = maybe?.dealBars || maybe?.state?.dealBars || [];
                if (bars.length) return bars;
            } catch (_) { }

            return [];
        }

        function ensureContainer() {
            let el = abRoot.querySelector("#container-bundle-selector");
            if (!el) {
                el = document.createElement("div");
                el.id = "container-bundle-selector";
                const anchor =
                    abRoot.querySelector("kaching-bundles-block") || abRoot.querySelector("#buy-buttons") || abRoot;
                anchor.parentNode.insertBefore(el, anchor);
            }
            el.style.display = el.style.display === "none" ? "block" : el.style.display;
            return el;
        }

        function findWidget() {
            return (
                abRoot.querySelector("kaching-bundles-block.kaching-bundles") ||
                document.querySelector("kaching-bundles-block.kaching-bundles") ||
                abRoot.querySelector("kaching-bundles-block") ||
                document.querySelector("kaching-bundles-block")
            );
        }

        function buildCustomSelector(bars, widgetEl, containerEl) {
            let countDagen = 0;

            containerEl.innerHTML = bars
                .map((bar, idx) => {
                    const realBar = widgetEl?.querySelector(`.kaching-bundles__bar[data-deal-bar-id="${bar.id}"]`);
                    const priceTxt = realBar?.querySelector(".kaching-bundles__bar-price")?.textContent?.trim() || "";
                    const total = moneyNumber(priceTxt) || 0;
                    if (idx === 0) window.firstPriceSaved = total;

                    const validation = /\/products\/.*grote-honden/i.test(window.location.pathname);
                    countDagen = validation ? countDagen + 45 : countDagen + 30;
                    const countDagenString = String(countDagen);
                    const displayPrice = total / countDagen;
                    const priceLimited = displayPrice.toFixed(2);

                    const priceTxtFull = realBar?.querySelector(".kaching-bundles__bar-full-price")?.textContent?.trim() || "";
                    const totalFull = moneyNumber(priceTxtFull) || 0;

                    const priceDiscount = realBar?.querySelector(".kaching-bundles__bar-label")?.textContent?.trim() || "";

                    let qtyScoops = "";
                    if (/\/products\/.*dental-powder/i.test(window.location.pathname)) {
                        qtyScoops = `${/\/products\/.*grote-honden/i.test(window.location.pathname) ? 90 * (idx + 1) + " schepjes" : 60 * (idx + 1) + " schepjes"}`;
                    } else {
                        qtyScoops = `${/\/products\/.*grote-honden/i.test(window.location.pathname) ? 90 * (idx + 1) + " chewies" : 60 * (idx + 1) + " chewies"}`;
                    }

                    const fmt = detectFormatSample(priceTxt);

                    if (!abRoot.querySelector(".t29-b-test-weight")) {
                        return (
                            `<div class="relative option-item js-selector js-option-item" data-deal-id="${bar.id}" data-price-quantity="${priceTxt}" data-full-price-quantity="${priceTxtFull}" data-bar-id="${idx}">` +
                            `<div class="option__item_container">` +
                            (idx === 1 ? `<span class="badge js-badge">Aanbevolen</span>` : "") +
                            (idx === bars.length - 1 ? `<span class="badge js-badge meeste">MEESTE VOORDEEL</span>` : "") +
                            `<span class="quantity"><span class="qty-bar">${bar.title}<span class="qty-scoops"> (${qtyScoops})</span></span><span class="js-price">${countDagenString} dagen voorraad</span></span>` +
                            `<span class="price js-dag" data-price="${total}" data-full-price="${totalFull}" data-count-dag="${countDagen}">${fmt.symbolIsPrefix ? fmt.symbol : ""}${(fmt.usesCommaDecimal ? priceLimited.replace(".", ",") : priceLimited)}${fmt.symbolIsPrefix ? "" : " " + fmt.symbol} per dag (${countDagenString} dagen voorraad)</span>` +
                            `</div>` +
                            (priceDiscount.length > 1 ? `<div class="amount_off_tag">${priceDiscount}</div>` : "") +
                            `</div>`
                        );
                    } else {
                        return (
                            `<div class="relative option-item js-selector js-option-item" data-deal-id="${bar.id}" data-price-quantity="${priceTxt}" data-full-price-quantity="${priceTxtFull}" data-bar-id="${idx}">` +
                            `<div class="option__item_container">` +
                            (idx === 1 ? `<span class="badge js-badge">Aanbevolen</span>` : "") +
                            (idx === bars.length - 1 ? `<span class="badge js-badge meeste">MEESTE VOORDEEL</span>` : "") +
                            `<span class="quantity"><span class="qty-bar">${bar.title}</span><span class="js-price">${countDagenString} dagen voorraad</span></span>` +
                            `<span class="price js-dag" data-price="${total}" data-full-price="${totalFull}" data-count-dag="${countDagen}">${qtyScoops}</span>` +
                            `</div>` +
                            (priceDiscount.length > 1 ? `<div class="amount_off_tag">${priceDiscount}</div>` : "") +
                            `</div>`
                        );
                    }
                })
                .join("");

            containerEl.querySelectorAll("div.js-option-item").forEach((qtySelector) => {
                qtySelector.addEventListener("click", () => {
                    containerEl.querySelectorAll(".js-option-item.selected").forEach((i) => i.classList.remove("selected"));
                    qtySelector.classList.add("selected");

                    const dealId = qtySelector.getAttribute("data-deal-id");
                    const realRad = abRoot.querySelector(`input[name^="kaching-bundles-deal"][value="${dealId}"]`);
                    const barEl = realRad ? realRad.closest(".kaching-bundles__bar") : null;

                    if (realRad) realRad.click();
                    updateButtonPrice(barEl);

                    const formEl = document.querySelector("#buy-buttons product-form form");
                    if (formEl) {
                        let quantityInput = formEl.querySelector('input[name="quantity"]');
                        if (!quantityInput) {
                            quantityInput = document.createElement("input");
                            quantityInput.type = "hidden";
                            quantityInput.name = "quantity";
                            formEl.appendChild(quantityInput);
                        }

                        quantityInput.value =
                            qtySelector.querySelector(".quantity")?.textContent?.trim()?.split(" ")[0] || "1";
                    }

                    updateRecs();
                    scheduleWriteATCPrices(document);
                });
            });
        }

        function tryBuildCustomSelector() {
            const widgetEl = findWidget();
            const containerEl = ensureContainer();

            if (!widgetEl) {
                document.addEventListener(
                    "kaching-bundles-initialized",
                    () => {
                        const w2 = findWidget();
                        const bars2 = getBarsFromAnySource(w2);
                        if (bars2.length) buildCustomSelector(bars2, w2, containerEl);
                        bindKachingPriceSync(document);
                    },
                    { once: true }
                );
                return;
            }

            let bars = getBarsFromAnySource(widgetEl);
            if (!bars.length) {
                const onReady = () => {
                    const b = getBarsFromAnySource(widgetEl);
                    if (b.length) {
                        buildCustomSelector(b, widgetEl, containerEl);
                        cleanup();
                        bindKachingPriceSync(document);
                    }
                };
                const cleanup = () => {
                    document.removeEventListener("kaching-bundles-initialized", onReady);
                    widgetEl.removeEventListener("deal-bar-selected", onReady);
                    widgetEl.removeEventListener("variant-selected", onReady);
                };
                document.addEventListener("kaching-bundles-initialized", onReady);
                widgetEl.addEventListener("deal-bar-selected", onReady);
                widgetEl.addEventListener("variant-selected", onReady);
                setTimeout(onReady, 1500);
                return;
            }

            buildCustomSelector(bars, widgetEl, containerEl);

            if (bars[1]?.id) {
                const toClick = abRoot.querySelector(`[data-deal-id="${bars[1].id}"]`);
                if (toClick) toClick.click();
            }

            bindKachingPriceSync(document);
        }

        tryBuildCustomSelector();

        const initialInput = abRoot.querySelector(".variant-input:checked");
        if (initialInput) {
            const initialItem = initialInput.closest(".option-item");
            const initialLabelEl = initialItem?.querySelector(".label");
            if (initialLabelEl) {
                syncBundleVariants(initialLabelEl.textContent.trim());
            }
        }

        abRoot.querySelectorAll(".tooltip-wrapper").forEach((tooltip) => {
            tooltip.addEventListener("mouseover", () => {
                tooltip.classList.add("active");
            });
            tooltip.addEventListener("mouseout", () => {
                tooltip.classList.remove("active");
            });
        });

        abRoot.querySelectorAll(".tooltip-close").forEach((btn) => {
            btn.addEventListener("click", () => {
                const wrapper = btn.closest(".tooltip-wrapper");
                if (wrapper) wrapper.classList.remove("active");
            });
        });

        const isLargeDog = /\/products\/.*grote-honden/i.test(window.location.pathname);
        const LARGE_DOG_WEIGHT_KEY = "gh:lastWeightLargeDog";
        const LARGE_DOG_ALLOWED = ["20-30", "30-40", "40-50", "above-50"];

        function saveLargeDogWeight(value) {
            if (LARGE_DOG_ALLOWED.includes(value)) localStorage.setItem(LARGE_DOG_WEIGHT_KEY, value);
            else localStorage.removeItem(LARGE_DOG_WEIGHT_KEY);
        }

        function getSavedLargeDogWeight() {
            const v = localStorage.getItem(LARGE_DOG_WEIGHT_KEY);
            if (LARGE_DOG_ALLOWED.includes(v)) return v;
        }

        function applySavedLargeDogWeight() {
            if (!weightGrp) return;
            const saved = getSavedLargeDogWeight();
            if (!saved) return;
            const savedEl = abRoot.querySelector(`.option-item.js-weight[data-value="${saved}"]`);
            if (savedEl && abRoot.querySelector(".js-part-grotehond")) {
                weightGrp.querySelectorAll(".option-item.selected").forEach((el) => el.classList.remove("selected"));
                if (abRoot.querySelector(".js-part-normal")) abRoot.querySelector(".js-part-normal").style.display = "none";
                abRoot.querySelector(".js-part-grotehond").style.display = "flex";
                abRoot.querySelector(".gh-segment").style.display = "inline-block";
                setTimeout(() => {
                    savedEl.classList.add("selected");
                    savedEl.click();
                }, 500);
            }
        }

        const weightMap = isLargeDog
            ? { "20-30": 2, "30-40": 3, "40-50": 4, "above-50": 5 }
            : { "under-10": 1, "10-20": 2, "20-30": 3, "above-30": 4, "30-40": 4, "40-50": 5, "above-50": 6 };

        const bundleIndexFor = isLargeDog
            ? { "20-30": 1, "30-40": 1, "40-50": 2, "above-50": 3 }
            : { "under-10": 1, "10-20": 1, "20-30": 2, "above-30": 3, "30-40": 3, "40-50": 3, "above-50": 3 };

        function updateRecs() {
            if (!weightGrp || !step1Rec || !step3Rec) return;
            const sel1 = weightGrp.querySelector(".option-item.js-weight.selected");
            const sel2 = abRoot.querySelector(".js-selector.selected.option-item");
            if (variantGrp) {
                const recommendationVariant = abRoot.querySelector(".js-variant-recommendation");
                const selVariant = variantGrp.querySelector(".option-item.selected");
                if (selVariant && recommendationVariant) {
                    recommendationVariant.innerHTML = ` ${selVariant.querySelector(".label").textContent}`;
                }
            }
            if (sel1) {
                document.querySelectorAll(".js-hide").forEach((el, index) => {
                    if (index > sel1.dataset.chews - 1) el.style.display = "none";
                    else el.style.display = "inline-block";
                });

                let chewText = "";
                if (sel1.dataset.chews == 1) {
                    chewText = /\/products\/.*dental-powder/i.test(window.location.pathname) ? "schepje" : "snoepje";
                } else {
                    chewText = /\/products\/.*dental-powder/i.test(window.location.pathname) ? "schepjes" : "chewies";
                }

                step1Rec.innerHTML = `${sel1.querySelector(".label").textContent}`;
                const recChews = document.querySelector(".js-recommended-chews");
                if (recChews) recChews.innerHTML = `${sel1.dataset.chews} ${chewText} per dag`;
            }
            if (sel2) {
                step3Rec.innerHTML = sel2.querySelector(".qty-bar").textContent;
            }
        }

        function clickBundle(idx) {
            const bars = abRoot.querySelectorAll("kaching-bundle .kaching-bundles__bar");
            if (!bars.length) return;
            const i = Math.min(Math.max(idx, 0), bars.length - 1);
            const barClick = bars[i];
            const label = barClick.querySelector("label");
            const labelEmulate = abRoot.querySelector('[data-bar-id="' + i + '"]');
            if (label) label.click();
            if (labelEmulate) labelEmulate.click();
            updateButtonPrice(barClick);
            scheduleWriteATCPrices(document);
        }

        function syncBundleVariants(variantTitle) {
            abRoot
                .querySelectorAll("kaching-bundle select.kaching-bundles__bar-variant-select.kaching-bundles-option")
                .forEach((selectEl) => {
                    const option = selectEl.querySelector(
                        `option.kaching-bundles-option-value[data-value="${variantTitle}"]`
                    );
                    if (option) {
                        selectEl.value = option.value;
                        selectEl.dispatchEvent(new Event("change", { bubbles: true }));
                    }
                });

            abRoot.querySelectorAll(".variant-picker__option-values").forEach((selectElOriginal) => {
                const optionOriginal = selectElOriginal.querySelector(`label[data-value="${variantTitle}"]`);
                if (optionOriginal) optionOriginal.click();
            });

            scheduleWriteATCPrices(document);
        }

        function updateBundleSubtitles() {
            if (!weightGrp) return;
            const sel = weightGrp.querySelector(".option-item.js-weight.selected")?.dataset?.value || "";
            const d = weightMap[sel] || 2;
            const daysPerPot = /\/products\/.*grote-honden/i.test(window.location.pathname) ? 90 / d : 60 / d;

            abRoot.querySelectorAll("#container-bundle-selector .js-selector.js-option-item").forEach((bar) => {
                const titleText = bar.querySelector(".quantity")?.textContent?.trim() || "";
                const priceDag = bar.querySelector(".js-dag")?.dataset?.price || null;
                const qty = parseInt(titleText, 10) || 1;
                const days = daysPerPot * qty;

                if (priceDag) {
                    setTimeout(() => {
                        const voorraadDagen = bar.querySelector(".js-price")?.textContent || "";
                        const dagChange = (parseFloat(priceDag) / days).toFixed(2);
                        const sample = bar.getAttribute("data-price-quantity") || "";
                        const fmt = detectFormatSample(sample);

                        if (!abRoot.querySelector(".t29-b-test-weight")) {
                            bar.querySelector(".js-dag").textContent =
                                (fmt.symbolIsPrefix ? fmt.symbol : "") + (fmt.usesCommaDecimal ? dagChange.replace(".", ",") : dagChange) + (fmt.symbolIsPrefix ? "" : " " + fmt.symbol) + ` per dag (${voorraadDagen})`;
                        } else {
                            const qs = bar.querySelector(".qty-scoops");
                            if (qs) qs.style.display = "none";
                            bar.querySelector(".js-dag").textContent = qs ? qs.textContent : "";
                        }
                    }, 5);
                }

                const subtitleEl = bar.querySelector(".quantity .js-price");
                if (subtitleEl) subtitleEl.textContent = `${days.toString().replace(".", ",")} dagen voorraad`;
            });
        }

        const el = document.querySelector("#container-bundle-selector");
        if (el) {
            el.style.display = "flex";
            el.style.visibility = "visible";
            el.hidden = false;
            el.style.opacity = 1;
        }

        function clickShowGroteHond(item) {
            if (!item) return;
            if (item.classList.contains("js-change-grotehond")) {
                if (abRoot.querySelector(".js-part-grotehond")) {
                    abRoot.querySelector(".js-part-normal").style.display = "none";
                    abRoot.querySelector(".js-part-grotehond").style.display = "flex";
                }
                abRoot.querySelector(".option-item.js-change-normal")?.nextElementSibling?.click();
                abRoot.querySelector(".option-item.js-change-normal")?.nextElementSibling?.classList?.add("selected");
                const seg = abRoot.querySelector(".gh-segment");
                if (seg) seg.style.display = "inline-block";
                setTimeout(() => {
                    abRoot.querySelector(".gh-tab[data-value='grotehond']")?.click();
                }, 600);
            }
            if (item.classList.contains("js-change-normal")) {
                if (abRoot.querySelector(".option-item.js-change-grotehond")) {
                    abRoot.querySelector(".option-item.js-change-grotehond")?.previousElementSibling?.click();
                    abRoot.querySelector(".option-item.js-change-grotehond")?.previousElementSibling?.classList?.add("selected");
                    if (abRoot.querySelector(".js-part-grotehond")) {
                        abRoot.querySelector(".js-part-normal").style.display = "flex";
                        abRoot.querySelector(".js-part-grotehond").style.display = "none";
                        const seg = abRoot.querySelector(".gh-segment");
                        if (seg) seg.style.display = "none";
                    }
                }
                if (abRoot.querySelector(".gh-tab[data-value='regular']")) {
                    setTimeout(() => {
                        abRoot.querySelector(".gh-tab[data-value='regular']")?.click();
                    }, 600);
                }
            }
            updateRecs();
            scheduleWriteATCPrices(document);
        }

        function updateBundleBadges() {
            if (!weightGrp) return;
            const sel = weightGrp.querySelector(".option-item.js-weight.selected")?.dataset?.value || "";
            const recIdx = bundleIndexFor[sel] ?? 1;
            const bars = abRoot.querySelectorAll("#container-bundle-selector .js-selector.js-option-item");
            if (!bars.length) return;

            bars.forEach((bar) => {
                bar.querySelectorAll(".badge.js-badge, .badge.meeste, .badge").forEach((el) => el.remove());
            });

            bars.forEach((bar, idx) => {
                const container = bar.querySelector(".option__item_container");
                if (!container) return;

                if (idx === recIdx && idx < bars.length - 1) {
                    const badge = document.createElement("span");
                    badge.className = "badge js-badge";
                    badge.textContent = "Aanbevolen";
                    container.appendChild(badge);
                } else if (idx === bars.length - 1 && idx != recIdx) {
                    const badge = document.createElement("span");
                    badge.className = "badge meeste";
                    badge.textContent = "MEESTE VOORDEEL";
                    container.appendChild(badge);
                } else if (idx === recIdx && idx === bars.length - 1) {
                    const badge = document.createElement("span");
                    badge.className = "badge js-badge";
                    badge.textContent = "Aanbevolen";
                    container.appendChild(badge);
                }
            });
        }

        function onWeightChange() {
            updateRecs();
            const sel = weightGrp.querySelector(".option-item.selected")?.dataset?.value || "";
            clickBundle(bundleIndexFor[sel] ?? 1);
            updateBundleSubtitles();
            updateBundleBadges();
            const v = weightGrp.querySelector(".option-item.selected")?.getAttribute("data-value");
            if (v) saveLargeDogWeight(v);
            scheduleWriteATCPrices(document);
        }

        function onVariantChange(e) {
            const item = e.target.closest(".option-item");
            if (!item || !variantGrp) return;
            const variantTitle = item.querySelector(".label")?.textContent?.trim() || "";

            variantGrp.querySelectorAll(".option-item.selected").forEach((el) => el.classList.remove("selected"));
            item.classList.add("selected");

            syncBundleVariants(variantTitle);

            const activeRad = abRoot.querySelector(`.kaching-bundles__bar.kaching-bundles__bar--selected`);
            updateButtonPrice(activeRad);
            updateRecs();
            scheduleWriteATCPrices(document);
        }

        const choiceSection = document.querySelector(".choice-section");
        if (choiceSection) {
            choiceSection.addEventListener("click", (e) => {
                const itemShow = e.target.closest(".option-item");
                clickShowGroteHond(itemShow);
            });
        }

        if (weightGrp) {
            weightGrp.addEventListener("click", (e) => {
                const item = e.target.closest(".option-item");
                if (!item) return;
                weightGrp.querySelectorAll(".option-item.selected").forEach((el) => el.classList.remove("selected"));
                item.classList.add("selected");
                onWeightChange();
            });
        }

        abRoot.querySelectorAll(".variant-input").forEach((input) => {
            input.addEventListener("change", onVariantChange);
        });

        applySavedLargeDogWeight();
        bindKachingPriceSync(document);
        scheduleWriteATCPrices(document);
    }

    document.addEventListener("DOMContentLoaded", function () {
        const customWidgetContainer = document.querySelectorAll("[option-data-bar-id]");
        customWidgetContainer.forEach(function (container) {
            container.addEventListener("click", function () {
                const id = container.getAttribute("option-data-bar-id");
                const correspondentContainer = document.querySelector(`[data-bar-id="${id}"]`);
                if (correspondentContainer) correspondentContainer.click();
            });
        });
    });

    document.addEventListener("DOMContentLoaded", () => {
        const MAX_WAIT = 1500;
        const INTERVAL = 100;
        let elapsedb = 0;
        let elapseda = 0;

        const pollerA = setInterval(() => {
            if (document.querySelector(".kaching-bundles__bar")) {
                clearInterval(pollerA);
                document.querySelectorAll(".prod__option-label.prod__option-label__quantity").forEach((el) => {
                    el.style.display = "none";
                });
                document
                    .querySelectorAll(".form__input-wrapper.form__input-wrapper--select.quantity-selector")
                    .forEach((el) => {
                        el.style.display = "none";
                    });
            } else if ((elapseda += INTERVAL) >= MAX_WAIT) {
                clearInterval(pollerA);
                document.querySelectorAll("kaching-bundle:not(.custom-bundle)").forEach((el) => {
                    el.style.display = "block";
                });
            }
        }, INTERVAL);

        const pollerb = setInterval(() => {
            if (document.body.classList.contains("data-selector-ab") && document.querySelector(".kaching-bundles__bar")) {
                clearInterval(pollerb);
                initSectionFunction();
                bindKachingPriceSync(document);
            } else if ((elapsedb += INTERVAL) >= MAX_WAIT) {
                clearInterval(pollerb);
                document.querySelectorAll("kaching-bundle").forEach((el) => {
                    el.style.display = "block";
                });

                const kachingBundlesBlock = document.querySelector("kaching-bundles-block");
                const activeBarKachingInitial = document.querySelector(`.kaching-bundles__bar.kaching-bundles__bar--selected`);
                updateButtonPrice(activeBarKachingInitial);
                bindKachingPriceSync(document);

                if (kachingBundlesBlock && !kachingBundlesBlock.__fallbackPriceBound) {
                    kachingBundlesBlock.__fallbackPriceBound = true;
                    kachingBundlesBlock.addEventListener("deal-bar-selected", () => {
                        const activeBarKaching = document.querySelector(`.kaching-bundles__bar.kaching-bundles__bar--selected`);
                        updateButtonPrice(activeBarKaching);
                    });
                    kachingBundlesBlock.addEventListener("variant-selected", () => {
                        const activeBarKaching = document.querySelector(`.kaching-bundles__bar.kaching-bundles__bar--selected`);
                        updateButtonPrice(activeBarKaching);
                    });
                }
            }
        }, INTERVAL);
    });
})();



// PRODUCT SELECTOR AJAX NAVIGATION - append to end of section-selector.js

(function () {

    if (document.body.classList.contains("data-selector-ab")) return;

    var IS_NAV = false;

    function showLoader() {
        if (document.getElementById("ps-loading-overlay")) return;

        if (!document.getElementById("ps-loading-style")) {
            var css =
                "#ps-loading-overlay{position:fixed;inset:0;z-index:99999;" +
                "background:rgba(0,0,0,.22);display:flex;align-items:center;" +
                "justify-content:center;backdrop-filter:saturate(120%) blur(2px)}" +
                "#ps-loading-overlay .box{display:flex;flex-direction:column;" +
                "gap:10px;align-items:center;justify-content:center;padding:18px}" +
                "#ps-loading-overlay .spinner{width:36px;height:36px;" +
                "border-radius:50%;border:4px solid rgba(255,255,255,.35);" +
                "border-top-color:#fff;animation:ps-spin .8s linear infinite}" +
                "@keyframes ps-spin{to{transform:rotate(360deg)}}" +
                "body.ps-loading{pointer-events:none;user-select:none}";
            var st = document.createElement("style");
            st.id = "ps-loading-style";
            st.textContent = css;
            document.head.appendChild(st);
        }

        var overlay = document.createElement("div");
        overlay.id = "ps-loading-overlay";
        overlay.innerHTML = '<div class="box"><div class="spinner"></div></div>';
        document.body.appendChild(overlay);
        document.body.classList.add("ps-loading");
    }

    function hideLoader() {
        var el = document.getElementById("ps-loading-overlay");
        if (el) el.remove();
        document.body.classList.remove("ps-loading");
    }

    function reExecuteScripts(container) {
        var _orig = document.addEventListener.bind(document);
        document.addEventListener = function (type, listener, options) {
            if (type === "DOMContentLoaded") {
                try { listener.call(document, { type: "DOMContentLoaded", target: document }); } catch (e) {}
                return;
            }
            return _orig(type, listener, options);
        };
        try {
            Array.from(container.querySelectorAll("script")).forEach(function (oldScript) {
                var src = oldScript.getAttribute("src") || "";
                if (src && document.querySelector('script[src="' + src + '"]')) return;
                var type = (oldScript.getAttribute("type") || "").toLowerCase();
                if (type === "application/json") return;
                var newScript = document.createElement("script");
                Array.from(oldScript.attributes).forEach(function (attr) {
                    newScript.setAttribute(attr.name, attr.value);
                });
                if (oldScript.textContent) newScript.textContent = oldScript.textContent;
                oldScript.parentNode.replaceChild(newScript, oldScript);
            });
        } finally {
            document.addEventListener = _orig;
        }
    }

    function reinitKaching() {
        return new Promise(function (resolve) {
            try { window.kachingBundlesInitialized = false; } catch (e) {}
            try { window.kachingBundlesDisableAutoInitialize = false; } catch (e) {}
            try { window.kachingBundlesEnabled = true; } catch (e) {}
            if (typeof window.kachingBundlesInitialize === "function") {
                setTimeout(function () { window.kachingBundlesInitialize(); }, 0);
            }
            if (window.kachingBundlesInitialized) return resolve();
            var timer = setTimeout(resolve, 6000);
            function onDone() {
                window.removeEventListener("kaching-bundles-initialized", onDone);
                clearTimeout(timer);
                resolve();
            }
            window.addEventListener("kaching-bundles-initialized", onDone);
        });
    }

    function syncKachingConfig(fetchedDoc) {
        if (!fetchedDoc) return;
        var incoming = fetchedDoc.querySelector('script#kaching-bundles-config[type="application/json"]');
        if (!incoming) return;
        var current = document.querySelector('script#kaching-bundles-config[type="application/json"]');
        if (!current) document.head.appendChild(incoming.cloneNode(true));
        else current.textContent = incoming.textContent;
    }

    function updateActiveLink(targetUrl) {
        document.querySelectorAll(".product-selector-normal, .product-selector-grote").forEach(function (link) {
            try {
                var linkPath = new URL(link.getAttribute("href") || "", location.href).pathname;
                var targetPath = new URL(targetUrl, location.href).pathname;
                link.classList.toggle("active", linkPath === targetPath);
            } catch (e) {}
        });
    }

    function pushUrl(url) {
        try {
            var u = new URL(url, location.href);
            history.pushState({ psNav: true, url: u.toString() }, "", u.toString());
        } catch (e) {}
    }

    function navigateTo(url) {
        if (IS_NAV || !url) return;
        IS_NAV = true;
        showLoader();

        var sectionEl =
            document.querySelector('[id^="shopify-section-"][id$="__main"]') ||
            document.querySelector('[id^="shopify-section-"]');

        if (!sectionEl) {
            hideLoader();
            IS_NAV = false;
            location.href = url;
            return;
        }

        var sectionId = sectionEl.id.replace(/^shopify-section-/, "");

        fetch(url + "?sections=" + encodeURIComponent(sectionId), {
            headers: { "X-Requested-With": "XMLHttpRequest" },
            credentials: "same-origin"
        })
        .then(function (res) { return res.json(); })
        .then(function (json) {
            var html = json && json[sectionId];
            if (!html) return;
            sectionEl.innerHTML = html;
            document.dispatchEvent(new CustomEvent("shopify:section:load", { bubbles: true, detail: { sectionId: sectionId } }));
            sectionEl.dispatchEvent(new CustomEvent("shopify:section:load", { bubbles: false, detail: { sectionId: sectionId } }));
            reExecuteScripts(sectionEl);
        })
        .then(function () {
            return fetch(url, { credentials: "same-origin" })
                .then(function (r) { return r.text(); })
                .then(function (pageHtml) {
                    var doc = new DOMParser().parseFromString(pageHtml, "text/html");
                    syncKachingConfig(doc);
                    var newTitle = doc.querySelector(".pdp-config-title h1");
                    var currentTitle = document.querySelector(".pdp-config-title h1");
                    if (newTitle && currentTitle) currentTitle.textContent = newTitle.textContent;
                    if (doc.title) document.title = doc.title;
                })
                .catch(function () {});
        })
        .then(function () { return reinitKaching(); })
        .then(function () {
            // Reset observer flag so it re-binds after DOM swap
            window.__atcPriceObsBound = false;

            pushUrl(url);
            updateActiveLink(url);
            bindSelectorLinks();

            // Re-bind price sync for new DOM
            var kachingBlock = document.querySelector("kaching-bundles-block");
            if (kachingBlock) kachingBlock.__psSyncBound = false;
            if (kachingBlock) kachingBlock.__priceSyncBound = false;

            // Delay to let Kaching render its bars
            setTimeout(function () {
                var priceEl   = document.getElementById("final-btn");
                var compareEl = document.getElementById("compare-btn");
                var dashEl    = document.getElementById("dash");

                if (priceEl && compareEl && dashEl) {
                    // Use the shared moneyNumber from the outer IIFE via the
                    // unified writeATCPrices exposed on the window for this patch
                    var selectedBar = kachingBlock
                        ? kachingBlock.querySelector(".kaching-bundles__bar--selected")
                        : null;

                    if (selectedBar) {
                        var barPrice   = selectedBar.querySelector(".kaching-bundles__bar-price");
                        var barCompare = selectedBar.querySelector(".kaching-bundles__bar-full-price");
                        var priceTxt   = barPrice   ? barPrice.textContent.trim()   : "";
                        var compareTxt = barCompare ? barCompare.textContent.trim() : "";

                        // Use robust parser (same logic as moneyNumber above)
                        function toNumSafe(txt) {
                            var s = (txt || "").replace(/[^\d.,]/g, "");
                            if (!s) return 0;
                            if (s.indexOf(",") !== -1 && s.indexOf(".") !== -1) {
                                if (s.lastIndexOf(",") > s.lastIndexOf(".")) {
                                    return parseFloat(s.replace(/\./g, "").replace(",", ".")) || 0;
                                }
                                return parseFloat(s.replace(/,/g, "")) || 0;
                            }
                            if (s.indexOf(",") !== -1) return parseFloat(s.replace(",", ".")) || 0;
                            return parseFloat(s) || 0;
                        }

                        var showCompare = !!(compareTxt && toNumSafe(compareTxt) > toNumSafe(priceTxt));

                        priceEl.textContent   = priceTxt;
                        compareEl.textContent = showCompare ? compareTxt : "";
                        dashEl.textContent    = showCompare ? " | " : "";
                    }
                }
            }, 600);

            var main = document.getElementById("MainContent");
            if (main) main.scrollIntoView({ behavior: "smooth", block: "start" });
            document.dispatchEvent(new CustomEvent("ps:navigation:complete", { bubbles: true, detail: { url: url } }));
        })
        .catch(function (err) {
            console.error("[ProductSelectorNav] Navigation failed:", err);
            location.href = url;
        })
        .finally(function () {
            hideLoader();
            IS_NAV = false;
        });
    }

    window.addEventListener("popstate", function (ev) {
        if (!ev.state || !ev.state.psNav) return;
        navigateTo(ev.state.url || location.href);
    });

    function bindSelectorLinks() {
        document.querySelectorAll(".product-selector-normal, .product-selector-grote").forEach(function (link) {
            if (link.__psSelectorBound) return;
            link.__psSelectorBound = true;
            link.addEventListener("click", function (e) {
                e.preventDefault();
                var href = link.getAttribute("href");
                if (!href) return;
                try {
                    if (new URL(href, location.href).pathname === location.pathname) return;
                } catch (e2) {}
                navigateTo(href);
            });
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bindSelectorLinks);
    } else {
        bindSelectorLinks();
    }

})();


// POST-NAVIGATION PATCH - ingredients popup + ATC price (SIMPLIFIED)

(function () {

    if (document.body.classList.contains("data-selector-ab")) return;

    // Ingredients popup via event delegation
    if (!document.__ingredientsPopupDelegated) {
        document.__ingredientsPopupDelegated = true;

        document.addEventListener("click", function (e) {
            var btn = e.target.closest("[data-ingredients-popup-open]");
            if (!btn) return;
            var popup = document.querySelector('[data-ingredients-popup="' + btn.getAttribute("data-ingredients-popup-open") + '"]');
            if (popup) popup.removeAttribute("hidden");
        });

        document.addEventListener("click", function (e) {
            var closeBtn = e.target.closest("[data-ingredients-popup-close]");
            if (!closeBtn) return;
            var popup = closeBtn.closest("[data-ingredients-popup]");
            if (popup) popup.setAttribute("hidden", "");
        });
    }

    // ATC price sync after navigation — now delegates to the unified
    // observer already set up by the main IIFE, so we just re-trigger.
    document.addEventListener("ps:navigation:complete", function () {
        var kachingBlock = document.querySelector("kaching-bundles-block");
        if (kachingBlock) {
            kachingBlock.__priceSyncBound = false;
            kachingBlock.__psSyncBound = false;
        }
        // The navigateTo handler already does the price injection with
        // a 600ms delay, so nothing extra needed here.
    });

})();